var Gr = Object.create;
var De = Object.defineProperty;
var $r = Object.getOwnPropertyDescriptor;
var rt = (e, t) => (t = Symbol[e]) ? t : /* @__PURE__ */ Symbol.for("Symbol." + e), oe = (e) => {
  throw TypeError(e);
};
var nt = (e, t, r) => t in e ? De(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Xe = (e, t) => De(e, "name", { value: t, configurable: !0 });
var me = (e) => [, , , Gr(e?.[rt("metadata")] ?? null)], it = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], ie = (e) => e !== void 0 && typeof e != "function" ? oe("Function expected") : e, Vr = (e, t, r, n, i) => ({ kind: it[e], name: t, metadata: n, addInitializer: (o) => r._ ? oe("Already initialized") : i.push(ie(o || null)) }), se = (e, t) => nt(t, rt("metadata"), e[3]), he = (e, t, r, n) => {
  for (var i = 0, o = e[t >> 1], a = o && o.length; i < a; i++) t & 1 ? o[i].call(r) : n = o[i].call(r, n);
  return n;
}, D = (e, t, r, n, i, o) => {
  var a, s, c, l, d, u = t & 7, C = !!(t & 8), P = !!(t & 16), A = u > 3 ? e.length + 1 : u ? C ? 1 : 2 : 0, E = it[u + 5], q = u > 3 && (e[A - 1] = []), h = e[A] || (e[A] = []), y = u && (!P && !C && (i = i.prototype), u < 5 && (u > 3 || !P) && $r(u < 4 ? i : { get [r]() {
    return et(this, o);
  }, set [r](I) {
    return tt(this, o, I);
  } }, r));
  u ? P && u < 4 && Xe(o, (u > 2 ? "set " : u > 1 ? "get " : "") + r) : Xe(i, r);
  for (var R = n.length - 1; R >= 0; R--)
    l = Vr(u, r, c = {}, e[3], h), u && (l.static = C, l.private = P, d = l.access = { has: P ? (I) => Wr(i, I) : (I) => r in I }, u ^ 3 && (d.get = P ? (I) => (u ^ 1 ? et : jr)(I, i, u ^ 4 ? o : y.get) : (I) => I[r]), u > 2 && (d.set = P ? (I, M) => tt(I, i, M, u ^ 4 ? o : y.set) : (I, M) => I[r] = M)), s = (0, n[R])(u ? u < 4 ? P ? o : y[E] : u > 4 ? void 0 : { get: y.get, set: y.set } : i, l), c._ = 1, u ^ 4 || s === void 0 ? ie(s) && (u > 4 ? q.unshift(s) : u ? P ? o = s : y[E] = s : i = s) : typeof s != "object" || s === null ? oe("Object expected") : (ie(a = s.get) && (y.get = a), ie(a = s.set) && (y.set = a), ie(a = s.init) && q.unshift(a));
  return u || se(e, i), y && De(i, r, y), P ? u ^ 4 ? o : y : i;
}, z = (e, t, r) => nt(e, typeof t != "symbol" ? t + "" : t, r), Fe = (e, t, r) => t.has(e) || oe("Cannot " + r), Wr = (e, t) => Object(t) !== t ? oe('Cannot use the "in" operator on this value') : e.has(t), et = (e, t, r) => (Fe(e, t, "read from private field"), r ? r.call(e) : t.get(e));
var tt = (e, t, r, n) => (Fe(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r), jr = (e, t, r) => (Fe(e, t, "access private method"), r);
import { ApplyModes as Hr, ApplyResponseCode as p, ApplicantType as J, ProviderApplyOperation as Ce, DeviceType as le, LogLevel as ae, useOmniApplyApiClient as g, BadRequestException as Ht, OmniApplyApiClientKey as zr, OmniApplyClientPlugin as Yr, getOmniApplyClient as Jr, ApiException as Qr, SendVerificationCodeStatus as zt, VerifyCodeStatus as Yt } from "@versatile-credit-apply/omni-apply-client";
import { computed as m, nextTick as L, toValue as f, onMounted as Jt, watch as G, unref as Zr, inject as be, createApp as Xr, onUnmounted as Qt, watchEffect as en, ref as N, toRaw as ot } from "vue";
import { get as Zt, find as tn, clamp as rn, flatten as nn, values as st, map as at, set as ct, keys as Ue, sortBy as lt, keyBy as on, last as Xt } from "lodash-es";
import { daysBetween as sn, formatDate as an, dayjs as dt, globalSuspense as cn, SynchronizingRouteGuard as er, HistoryRouteGuard as tr, useApplicationLocales as ln, useApplicationI18n as dn } from "@ui-kit/sdk";
import { daysBetween as dl, toLocalDate as ul, useApplicationI18n as pl } from "@ui-kit/sdk";
import { useMemoize as rr, useAsyncState as ue, computedAsync as un, useTimeoutFn as pn, watchDebounced as fn, useDebounceFn as mn, useScriptTag as nr } from "@vueuse/core";
import { defineStore as k, getActivePinia as Ae, createPinia as hn } from "pinia";
import { createPersistedState as yn } from "pinia-plugin-persistedstate";
import { compile as vn } from "path-to-regexp";
import { EventBus as gn } from "@primeuix/utils/eventbus";
import { getRumSession as te, reportBusinessEvent as Z, userAction as F } from "@ui-kit/instrumentation";
import ut from "js-cookie";
import { useRouter as je, createRouter as ir, routerKey as Pn, createRouterMatcher as wn, useRoute as or, createWebHashHistory as sr } from "vue-router";
import { useI18n as He } from "vue-i18n";
import Sn from "print-js";
Object.defineProperty(Array.prototype, "first", {
  enumerable: !1,
  configurable: !0,
  value: function() {
    if (this.length === 0)
      throw new Error("Array[] is empty");
    return this[0];
  }
});
Object.defineProperty(Array.prototype, "firstOrUndefined", {
  configurable: !0,
  enumerable: !1,
  value: function() {
    return this.length ? this[0] : void 0;
  }
});
Object.defineProperty(String.prototype, "includesIgnoreCase", {
  enumerable: !1,
  configurable: !0,
  value: function(e) {
    const t = this.length, r = e.length;
    if (r > t)
      return !1;
    for (let n = 0; n <= t - r; n++) {
      let i = 0;
      for (; i < r && // @ts-expect-error will be defined
      this[n + i].toLowerCase() === e[i].toLowerCase(); )
        i++;
      if (i === r)
        return !0;
    }
    return !1;
  }
});
Object.defineProperty(String.prototype, "startsWithIgnoreCase", {
  enumerable: !1,
  configurable: !0,
  value: function(e) {
    const t = this.length, r = e.length;
    if (r > t)
      return !1;
    for (let n = 0; n < r; n++)
      if (this[n].toLowerCase() !== e[n].toLowerCase())
        return !1;
    return !0;
  }
});
Object.defineProperty(String.prototype, "endsWithIgnoreCase", {
  enumerable: !1,
  configurable: !0,
  value: function(e) {
    const t = this.length, r = e.length;
    if (r > t)
      return !1;
    for (let n = 0; n < r; n++)
      if (
        // @ts-expect-error will be defined
        this[t - r + n].toLowerCase() !== e[n].toLowerCase()
      )
        return !1;
    return !0;
  }
});
function js(e, t, r = "/apply") {
  const n = Object.values(Hr).join("|"), i = new RegExp(`${r}/(${n})/`);
  return e.replace(i, `${r}/${t}/`);
}
const pt = (e, t, r) => !t || t === "$it" ? r : Zt(e, t), An = (e) => {
  if (e)
    return Array.isArray(e) ? e.length ? e[0] : void 0 : e.value?.length ? e.value[0] : void 0;
}, Hs = (e, t) => {
  const r = e.find(t);
  if (r) {
    const n = e.indexOf(r);
    n > -1 && e.splice(n, 1);
  }
}, Rn = (e, t) => {
  if (e.length < 2)
    return e;
  const r = ar(t);
  return e.slice().sort(r);
}, ar = (e) => {
  if (typeof e == "string")
    return Cn(e);
  if (typeof e == "function")
    return En(e);
  if (Array.isArray(e))
    return bn(e);
  throw new Error(`Invalid sort rule: ${e}`);
}, bn = (e) => {
  const t = e.map(ar);
  return (r, n) => {
    for (const i of t) {
      const o = i(r, n);
      if (o !== 0)
        return o;
    }
    return 0;
  };
}, En = (e) => (t, r) => {
  const n = e(t), i = e(r);
  return n === i ? 0 : n < i ? -1 : 1;
}, Cn = (e) => {
  let t = "", r = e, n = 1;
  r.startsWith("-") && (n = -1, r = r.slice(1));
  const i = r.indexOf(":");
  i > -1 && (t = r.slice(i + 1), r = r.slice(0, i));
  const o = t.includes("i");
  return (a, s) => {
    let c = pt(a, r), l = pt(s, r);
    return o && (c = typeof c == "string" ? c.toLowerCase() : c, l = typeof l == "string" ? l.toLowerCase() : l), c === l ? 0 : c < l ? -1 * n : n;
  };
}, zs = (e, t) => {
  let r = null;
  return () => {
    r && window.clearTimeout(r), r = window.setTimeout(e, t);
  };
}, Ys = (e, t) => {
  let r = null;
  return async () => (r && window.clearTimeout(r), new Promise((n, i) => {
    r = window.setTimeout(async () => {
      try {
        const o = await e();
        n(o);
      } catch (o) {
        i(o);
      }
    }, t);
  }));
}, ce = (e, t) => new Promise((r) => {
  setTimeout(() => {
    r(t());
  }, e);
}), Js = (e) => new Promise((t) => {
  setTimeout(() => {
    t();
  }, e);
}), Qs = (e) => (t) => {
  for (const r of e)
    if (!r(t))
      return !1;
  return !0;
}, Zs = (e) => e.responseCode === p.APPROVED, In = (e) => e.responseCode === p.PENDING, ft = (e) => e.responseCode === p.PREQUALIFIED || e.responseCode === p.PREAPPROVED, Xs = (e) => (t) => t.providerKey === e.providerKey, Mn = (e) => (t) => t.providerKey === e, cr = (e) => (t) => t.applicantType === e, ea = (e) => e.type ? cr(e.type) : () => !1, ta = cr(
  J.JOINT
), lr = (e) => (t) => t.type === e, ra = lr(J.PRIMARY), na = lr(J.JOINT), ia = (e, t) => (r) => e(r) && t(r), Be = (e, t) => "value" in e ? e.value.find(t) : e.find(t), oa = (e, t) => m(() => Be(e, t)), ke = (e, t) => "value" in e ? e.value.filter(t) : e.filter(t), sa = (e, t) => m(() => ke(e, t));
class qe {
  _value;
  _providerKey;
  _modifiers;
  constructor(t) {
    this._value = t;
    const r = t.indexOf(":");
    r > 0 ? (this._providerKey = t.substring(0, r), this._modifiers = new Map(
      t.substring(r + 1).split(":").map((n) => {
        const i = n.toLowerCase();
        return i.includes("=") ? i.split("=") : [i, "true"];
      })
    )) : (this._providerKey = t, this._modifiers = /* @__PURE__ */ new Map());
  }
  get providerKeyFqn() {
    return this._value;
  }
  get providerKey() {
    return this._providerKey;
  }
  get modifiers() {
    return this._modifiers;
  }
  get isJoint() {
    return this._modifiers.get("joint") === "true";
  }
  toString() {
    return this._value;
  }
}
const On = {
  asyncOfferAcceptance: !1,
  asyncApplicationSubmission: !1,
  asyncPrequalifySubmission: !1,
  submitAfterPrequalify: !1,
  asyncPrequalifySubmissionRequiresRefresh: !1,
  refreshApplicationAfterPrequalified: !1,
  displayPaymentCalculations: () => !0,
  displayPaymentPlanDetails: () => !0,
  excludePurchaseAmountFromMaxFinancing: !1,
  displayDeclineMessageWithOffer: !0,
  fetchPaymentPlansOnApproval: !0,
  fetchPaymentPlansOnPreauthApproval: !1,
  requiresAccountCreation: !1,
  requiresCodeVerification: !1,
  requiresEmailOnSmsVerification: !1,
  requiresSelectPlan: !0,
  supportsDownPaymentAdjustment: !0,
  supportsPurchaseAmountAdjustment: !1,
  supportsFullApply: !0,
  switchToFullApplyAfterPrequal: !1,
  termsType: "image",
  hydrationPostProcessing: {
    loadPaymentPlans: !0,
    loadPurchaseDetails: !1
  },
  accountFoundEndsApplication: !1
}, Tn = S(
  "acima",
  "acima_standard",
  {
    switchToFullApplyAfterPrequal: !0
  }
), _n = S("ads", "ads_standard", {
  accountFoundEndsApplication: !0,
  requiresSelectPlan: !1
}), Dn = S("aff", "aff_standard", {
  excludePurchaseAmountFromMaxFinancing: !0
}), Fn = S("aqua", "aqua_standard", {
  asyncPrequalifySubmission: !0,
  termsType: "none"
}), Nn = S(
  "bread",
  "bread_standard",
  {
    hydrationPostProcessing: {
      loadPaymentPlans: !1,
      loadPurchaseDetails: !0
    },
    requiresCodeVerification: !0,
    requiresEmailOnSmsVerification: !0
  }
), aa = S(
  "claritypay",
  "claritypay_standard"
), mt = S(
  "versatile",
  "internal"
), xn = S(
  "dividend",
  "dividend_standard"
), Ln = S(
  "fortiva",
  "fortiva_standard",
  {
    excludePurchaseAmountFromMaxFinancing: !0
  }
), Kn = S(
  "foundation",
  "foundation_standard",
  {
    asyncApplicationSubmission: !0,
    asyncPrequalifySubmission: !0,
    asyncPrequalifySubmissionRequiresRefresh: !0,
    refreshApplicationAfterPrequalified: !0,
    termsType: "none"
  }
), Un = S("gafco", "gaf_standard"), Bn = S(
  "genesis",
  "genesis_standard",
  {
    excludePurchaseAmountFromMaxFinancing: !0,
    termsType: "none"
  }
), kn = S(
  "greensky",
  "greensky_standard",
  {
    asyncOfferAcceptance: !0,
    displayDeclineMessageWithOffer: !1,
    requiresAccountCreation: !0,
    supportsPurchaseAmountAdjustment: !0,
    supportsFullApply: !1,
    termsType: "html"
  }
), qn = S("hfd", "hfd_standard", {
  excludePurchaseAmountFromMaxFinancing: !0,
  fetchPaymentPlansOnError: !0,
  fetchPaymentPlansOnPreauthApproval: !0,
  fetchPaymentPlansOnApproval: !1
}), Gn = S(
  "kafene",
  "kafene_standard"
), $n = S(
  "zibby",
  "katapult_standard",
  {
    fetchPaymentPlansOnApproval: !1,
    fetchPaymentPlansOnError: !1,
    fetchPaymentPlansOnPreauthApproval: !1
  }
), Vn = S(
  "koalafi",
  "koalafi_standard",
  {
    fetchPaymentPlansOnApproval: !1
  }
), Wn = S(
  "lendingclub",
  "lendingclub_standard",
  {
    excludePurchaseAmountFromMaxFinancing: !0
  }
), jn = S(
  "lendingpoint",
  "lendingpoint_standard"
), Hn = S(
  "momnt",
  "momnt_standard",
  {
    termsType: "none",
    supportsDownPaymentAdjustment: !1
  }
), zn = S(
  "powerpay",
  "powerpay_standard",
  {
    termsType: "none"
  }
), Yn = S("proceed", "proceed_standard", {
  excludePurchaseAmountFromMaxFinancing: !0,
  fetchPaymentPlansOnApproval: !1,
  fetchPaymentPlansOnPreauthApproval: !0
}), Jn = S(
  "progressive",
  "progressive_standard",
  {
    fetchPaymentPlansOnApproval: !1
  }
), Qn = S(
  "service_finance",
  "service_finance_standard",
  {
    displayPaymentCalculations: (e) => e.tags["risk-based"] !== "true",
    displayPaymentPlanDetails: (e) => e.tags["risk-based"] !== "true",
    supportsDownPaymentAdjustment: !1
  }
), Zn = S(
  "sonrava",
  "sonrava_standard"
), Xn = S("snap", "snap_standard", {
  fetchPaymentPlansOnApproval: !1
}), ei = S(
  "sunlight",
  "sunlight_standard",
  {
    termsType: "none",
    submitAfterPrequalify: !0
  }
), ti = S(
  "synchrony",
  "synchrony_standard",
  {
    excludePurchaseAmountFromMaxFinancing: !0
  }
), ri = S(
  "tdbank",
  "tdbank_standard"
), ni = S("tguc", "tguc_standard", {
  termsType: "none"
}), ii = S(
  "upgrade",
  "upgrade_standard",
  {
    termsType: "none",
    supportsDownPaymentAdjustment: !1
  }
), oi = S(
  "watercress",
  "watercress_standard",
  {
    asyncPrequalifySubmission: !0,
    termsType: "none",
    supportsDownPaymentAdjustment: !1
  }
), si = S(
  "wells_fargo",
  "wells_fargo_standard",
  {
    termsType: "none"
  }
), ai = [
  Tn,
  _n,
  Dn,
  Fn,
  Nn,
  xn,
  Ln,
  Kn,
  Un,
  Bn,
  kn,
  qn,
  Gn,
  $n,
  Vn,
  Wn,
  jn,
  Hn,
  zn,
  Yn,
  Jn,
  Qn,
  Zn,
  Xn,
  ei,
  ti,
  ri,
  ni,
  ii,
  oi,
  si
], x = (e) => e.indexOf(":") > 0 ? e.substring(0, e.indexOf(":")) : e, ca = (e) => e ? x(e) : null, K = (e) => {
  if (!e)
    return mt;
  let t = null;
  const r = (n) => n.providerId === e ? !0 : (t ??= x(e), n.providerKey === t);
  return ai.find(r) || mt;
};
function S(e, t, r) {
  return {
    ...On,
    ...r,
    providerId: e,
    providerKey: t
  };
}
class ci {
  _key;
  _applicant;
  _offers;
  _acceptedOffer;
  constructor(t, r, n) {
    this._key = gr(), this._applicant = t, this._offers = r, this._acceptedOffer = n;
  }
  get key() {
    return this._key;
  }
  get applicant() {
    return this._applicant;
  }
  get firstName() {
    return this._applicant.firstName || "";
  }
  get fullName() {
    return `${this.applicant.firstName} ${this.applicant.lastName}`.trim();
  }
  get offers() {
    return this._offers;
  }
  get prequalifiedOffers() {
    return ke(this._offers, ft);
  }
  get pendingOffers() {
    return ke(this._offers, In);
  }
  get acceptedOffer() {
    return this._acceptedOffer;
  }
  get isPrequalified() {
    return !this.hasAcceptedOffer && !!Be(this._offers, ft);
  }
  get hasAcceptedOffer() {
    return !!this._acceptedOffer;
  }
  get preauthResponseForAcceptedOffer() {
    if (this._acceptedOffer)
      return Be(
        this._offers,
        Mn(this._acceptedOffer.providerKey)
      );
  }
  get providerModuleForAcceptedOffer() {
    return K(this._acceptedOffer?.providerKey);
  }
}
class la {
  _offers;
  _providerConfigs;
  constructor(t, r) {
    this._offers = t, this._providerConfigs = r;
  }
  get offers() {
    return this._offers;
  }
  get acceptedOffers() {
    return [...this._offers.values()].filter((t) => t.hasAcceptedOffer);
  }
  get prequalifiedOffers() {
    const t = this.acceptedOffers.length > 0, r = [...this._offers.values()].filter(
      (n) => n.isPrequalified
    );
    return t ? r.map((n) => {
      const i = n.prequalifiedOffers.filter(
        (o) => this.supportsMultipleApplicants(o.providerKey)
      );
      return new ci(
        n.applicant,
        i,
        n.acceptedOffer
      );
    }) : r;
  }
  get singleOffer() {
    const t = this.prequalifiedOffers;
    return An(t);
  }
  get allPrequalifiedOffers() {
    return this.prequalifiedOffers.flatMap((t) => t.prequalifiedOffers);
  }
  get allPendingOffers() {
    return [...this._offers.values()].flatMap((t) => t.pendingOffers);
  }
  get jointApplicant() {
    return this._offers.get(J.JOINT);
  }
  get hasJointApplicant() {
    return this._offers.has(J.JOINT);
  }
  get hasAdditionalOffersToAccept() {
    const t = this.acceptedOffers;
    return !t.length || !(t.map(
      (n) => this.supportsMultipleApplicants(n.acceptedOffer?.providerKey)
    ).filter((n) => !n).length === 0) ? !1 : this.prequalifiedOffers.flatMap((n) => n.prequalifiedOffers).some((n) => this.supportsMultipleApplicants(n.providerKey));
  }
  supportsMultipleApplicants(t) {
    return t ? tn(this._providerConfigs, {
      providerKey: t
    })?.supportsMultipleApplicantOfferAcceptance ?? !1 : !1;
  }
}
class ye {
  _start = null;
  _resume = null;
  _responses = [];
  _firstResponse = null;
  _lastResponse = null;
  _approvedResponse = null;
  _provider;
  _mode;
  _initialProvider;
  _initialMode;
  _autoSubmit = !1;
  _approvalCodes = [
    p.APPROVED,
    p.PREQUALIFIED,
    p.PREQUALIFIED
  ];
  constructor(t, r) {
    this._provider = t, this._mode = r, this._initialProvider = t, this._initialMode = r;
  }
  async execute(t) {
    return this.appendResponse(await t(this.provider)), this;
  }
  appendResponse(t) {
    const r = {
      ...t,
      applyMode: t.provider?.operation === Ce.ACCEPT_OFFER ? "full" : this.mode
    };
    return this._responses.push(r), this._firstResponse ??= r, this.isApproved(r) && !this._approvedResponse && (this._approvedResponse = r), this._lastResponse = r, r;
  }
  get firstResponse() {
    if (!this._firstResponse)
      throw new Error("First Response not set!");
    return this._firstResponse;
  }
  get lastResponse() {
    if (!this._lastResponse)
      throw new Error("Last Response not set!");
    return this._lastResponse;
  }
  get approvedResponse() {
    return this._approvedResponse;
  }
  get autoSubmit() {
    return this._autoSubmit;
  }
  set autoSubmit(t) {
    this._autoSubmit = t;
  }
  get start() {
    return this._start;
  }
  set start(t) {
    this._start = t;
  }
  get resume() {
    return this._resume;
  }
  set resume(t) {
    this._resume = t;
  }
  get provider() {
    return this._provider;
  }
  set provider(t) {
    this._provider = t;
  }
  get mode() {
    return this._mode;
  }
  set mode(t) {
    this._mode = t;
  }
  get responses() {
    return [...this._responses];
  }
  isApproved(t) {
    return !!t.provider && this._approvalCodes.includes(t.provider?.responseCode);
  }
  hasLastResponse() {
    return this._lastResponse != null;
  }
}
class ve {
  _context;
  _approvalCodes = [
    p.APPROVED,
    p.PREQUALIFIED,
    p.PREQUALIFIED
  ];
  _declineCodes = [
    p.DECLINED,
    p.NOOFFER
  ];
  constructor(t) {
    this._context = t;
  }
  get firstResponse() {
    return this._context.firstResponse;
  }
  get lastResponse() {
    return this._context.lastResponse;
  }
  get allResponses() {
    return this._context.responses;
  }
  shouldSwitchProviders() {
    return !!this._context.lastResponse && (this._context.start === !0 || this._context.resume === !0);
  }
  nextProvider() {
    return this._context.approvedResponse?.provider ? this._context.approvedResponse.provider?.providerKey : this._context.lastResponse?.next?.provider?.providerKey;
  }
  nextApplyMode() {
    return this._context.approvedResponse?.applyMode ? this._context.approvedResponse.applyMode : this._context.lastResponse?.next?.applyMode;
  }
  isResumingNextProvider() {
    return this._context.resume === !0;
  }
  getResponseToContinueWith() {
    if (this._context.approvedResponse?.provider)
      return this._context.approvedResponse;
    const t = (i) => {
      const o = i.provider?.responseCode;
      return !!o && this._approvalCodes.includes(o);
    }, r = this._context.responses.find(t);
    if (r)
      return r;
    const n = (i) => {
      const o = i.provider?.responseCode;
      return !!o && this._declineCodes.includes(o);
    };
    return this._context.responses.every(n) ? this._context.responses[0] : this._context.lastResponse;
  }
  getResponseForProvider(t) {
    return this._context.responses.find(
      (r) => r.provider?.providerKey === t
    );
  }
  hasMultipleOffers() {
    const t = (r) => {
      const n = r.provider?.responseCode;
      return n === p.PREQUALIFIED || n === p.PREAPPROVED;
    };
    return this._context.responses.filter(t).length > 1;
  }
  hasSingleOffer() {
    const t = (r) => {
      const n = r.provider?.responseCode;
      return n === p.PREQUALIFIED || n === p.PREAPPROVED || n === p.APPROVED;
    };
    return this._context.responses.filter(t).length === 1;
  }
}
var li = /* @__PURE__ */ ((e) => (e.GROSS_MONTHLY = "gross_monthly", e.GROSS_ANNUAL = "gross_annual", e.NET_MONTHLY = "net_monthly", e.NET_ANNUAL = "net_annual", e))(li || {}), Ge;
((e) => {
  function t(i) {
    return typeof i != "object" ? !1 : "contentType" in i && "data" in i;
  }
  e.isContent = t;
  function r(i) {
    return {
      contentType: "text/html",
      data: i
    };
  }
  e.fromHtml = r;
  function n(i, o) {
    const a = Ie(i);
    return {
      contentType: o ?? Q.fromFilename(a.pathname) ?? "application/octet-stream",
      data: i
    };
  }
  e.fromUrl = n;
})(Ge || (Ge = {}));
var ht;
((e) => {
  function t(r) {
    return typeof r != "object" ? !1 : "content" in r && Ge.isContent(r.content);
  }
  e.isContents = t;
})(ht || (ht = {}));
var $e = /* @__PURE__ */ ((e) => (e.COMPONENT = "component", e.HTML = "html", e.IMAGE = "image", e.PDF = "pdf", e.UNKNOWN = "unknown", e.VNODE = "vnode", e))($e || {}), Q = /* @__PURE__ */ ((e) => (e.COMPONENT = "application/component", e.HTML = "text/html", e.IMAGE_GIF = "image/gif", e.IMAGE_JPEG = "image/jpeg", e.IMAGE_PNG = "image/png", e.JSON = "application/json", e.JSON_UTF8 = "application/json;charset=utf-8", e.MARKDOWN = "text/markdown", e.PDF = "application/pdf", e.TEXT = "text/plain", e.UNKNOWN = "application/octet-stream", e.VNODE = "application/vnode", e.XML = "text/xml", e.XML_APPLICATION = "application/xml", e))(Q || {});
const di = {};
for (const e in Q)
  di[e] = Q[e];
const ui = {
  gif: "image/gif",
  html: "text/html",
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  json: "application/json",
  md: "text/markdown",
  pdf: "application/pdf",
  png: "image/png",
  txt: "text/plain",
  xml: "text/xml"
  /* XML */
};
((e) => {
  function t(n) {
    const i = n?.split(".")?.pop()?.toLowerCase();
    return ui[i ?? ""] ?? "application/octet-stream";
  }
  e.fromFilename = t;
  function r(n) {
    if (n.startsWithIgnoreCase("data:"))
      return n.split(";")[0].split(":")[1] ?? null;
    const i = n.split("/");
    if (i.length < 2)
      return null;
    const o = decodeURIComponent(i.at(-1));
    return t(o);
  }
  e.fromUri = r;
})(Q || (Q = {}));
((e) => {
  function t(r) {
    switch (r?.toLowerCase()) {
      case "application/component":
        return "component";
      case "text/html":
        return "html";
      case "image/gif":
      case "image/jpeg":
      case "image/png":
        return "image";
      case "application/pdf":
        return "pdf";
      case "application/vnode":
        return "vnode";
      default:
        return "unknown";
    }
  }
  e.fromContentType = t;
})($e || ($e = {}));
var pi = /* @__PURE__ */ ((e) => (e[e.APPLY = 0] = "APPLY", e[e.PRINT = 1] = "PRINT", e))(pi || {});
class ge {
  _type;
  _capabilities = [];
  constructor(t) {
    this._type = t, this._capabilities.push(
      0
      /* APPLY */
    ), t === le.KIOSK && this._capabilities.push(
      1
      /* PRINT */
    );
  }
  get type() {
    return this._type;
  }
  get capabilities() {
    return [...this._capabilities];
  }
}
const fi = () => {
  if (window.kiosk)
    return new ge(le.KIOSK);
  const e = window.navigator.userAgent;
  return /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(e) ? new ge(le.TABLET) : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
    e
  ) ? new ge(le.MOBILE) : new ge(le.DESKTOP);
};
function da(e, t) {
  return e ? mi(e, t) : null;
}
function mi(e, t) {
  return {
    contentType: e.contentType ?? t ?? Q.UNKNOWN,
    data: e.body
  };
}
var hi = /* @__PURE__ */ ((e) => (e.EMAIL = "email", e.PHONE = "phone", e))(hi || {});
class yt {
  relative;
  url;
  constructor(t) {
    this.relative = typeof t == "string" && t.indexOf("://") < 0, this.url = vi(t);
  }
  get standard() {
    switch (this.protocol) {
      case "http:":
      case "https:":
      case "mailto:":
      case "tel:":
        return !0;
      default:
        return !1;
    }
  }
  get hash() {
    return this.url.hash;
  }
  get host() {
    return this.url.host;
  }
  get hostname() {
    return this.url.hostname;
  }
  get href() {
    return this.url.href;
  }
  get origin() {
    return this.url.origin;
  }
  get password() {
    return this.url.password;
  }
  get pathname() {
    return this.url.pathname;
  }
  get port() {
    return this.url.port;
  }
  get protocol() {
    return this.url.protocol;
  }
  get search() {
    return this.url.search;
  }
  get searchParams() {
    return this.url.searchParams;
  }
  get username() {
    return this.url.username;
  }
  toString() {
    return this.relative ? this.url.pathname + this.url.search + this.url.hash : this.url.toString();
  }
}
const dr = () => window.location.protocol + "//" + window.location.host, yi = () => dr() + window.location.pathname, ua = (e) => {
  try {
    return Ie(e);
  } catch {
    return null;
  }
}, Ie = (e) => e instanceof yt ? e : new yt(e), vi = (e) => {
  if (e instanceof URL)
    return e;
  try {
    return new URL(e);
  } catch {
  }
  let t = e;
  if (e.indexOf("://") < 0) {
    const r = dr();
    e.startsWith("/") ? t = r.endsWith("/") ? r + e.substring(1) : r + e : t = r.endsWith("/") ? r + e : r + "/" + e;
  }
  return new URL(t);
}, gi = (e, t = "file") => {
  try {
    return Ie(e).pathname?.split("/")?.pop() ?? t;
  } catch {
    return t;
  }
}, Pe = (e, t) => {
  const r = Ie(e), n = r.searchParams;
  return Object.keys(t).forEach((i) => {
    const o = t[i];
    o != null && n.set(i, o);
  }), r;
}, pa = (e, t = "") => {
  const r = {
    sid: t,
    url: e
  };
  return "/api/v1/proxy?" + new URLSearchParams(r).toString();
}, ze = "download", Pi = (e, t) => {
  ur(e, t ?? gi(e, ze));
}, vt = (e, t) => {
  const r = URL.createObjectURL(e);
  ur(r, t ?? ze);
}, ur = (e, t, r = "_blank") => {
  const n = document.createElement("a");
  n.href = e, n.download = t ?? ze, n.target = r, n.click();
}, wi = (e, t) => {
  e instanceof Promise ? e.then((r) => gt(r, t)) : "content" in e ? wi(e.downloadableContent ?? e.content, t) : gt(e, t);
}, gt = (e, t) => {
  e.data instanceof Blob ? vt(e.data, t) : typeof e.data != "string" || !Si(e.data) ? vt(
    new Blob([e.data], { type: e.contentType }),
    t
  ) : Pi(e.data, t);
}, Si = (e) => e.startsWith("/") || e.startsWith("http://") || e.startsWith("https://") ? !0 : e.startsWith("data:");
async function pr(e) {
  const t = new TextEncoder().encode(e), r = await crypto.subtle.importKey("raw", t, "HKDF", !1, [
    "deriveKey"
  ]);
  return await crypto.subtle.deriveKey(
    {
      name: "HKDF",
      salt: new Uint8Array(0),
      info: new TextEncoder().encode("encryption"),
      hash: "SHA-256"
    },
    r,
    { name: "AES-GCM", length: 256 },
    !0,
    ["encrypt", "decrypt"]
  );
}
const Ai = (e = 12) => crypto.getRandomValues(new Uint8Array(e));
async function Ri(e, t, r) {
  const n = await crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv: r
    },
    t,
    new TextEncoder().encode(e)
  );
  return Me.toString(n);
}
async function bi(e, t, r) {
  const n = await crypto.subtle.decrypt(
    {
      name: "AES-GCM",
      iv: r
    },
    t,
    Me.toBinary(e)
  );
  return new TextDecoder().decode(n);
}
const Me = {
  toBinary: (e) => new Uint8Array(
    atob(e).split("").map((t) => t.charCodeAt(0))
  ),
  toString: (e) => {
    let t = "";
    const r = e.byteLength, n = 32768, i = Math.ceil(r / n);
    for (let o = 0; o < i; o++) {
      const a = e.slice(
        o * n,
        Math.min((o + 1) * n, r)
      );
      t += String.fromCharCode(...new Uint8Array(a));
    }
    return btoa(t);
  }
};
var Y = /* @__PURE__ */ ((e) => (e.CEIL = "ceil", e.FLOOR = "floor", e.HALF_EVEN = "halfeven", e))(Y || {});
const Ei = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  roundingMode: "ceil"
}), Ci = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  roundingMode: "floor"
}), Pt = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  roundingMode: "halfExpand"
}), Ii = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
  roundingMode: "ceil"
}), Mi = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
  roundingMode: "floor"
}), wt = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
  roundingMode: "halfExpand"
}), fa = (e) => e == null ? null : typeof e == "number" ? e : parseFloat(e), ma = (e, t = "cents", r = !1, n = "halfeven") => {
  if (e == null)
    return null;
  let i = typeof e == "string" ? parseFloat(e) : e;
  return t === "cents" && (i = i / 100), Oi(r, n).format(i);
}, Ee = (e, t, r = 0, n = 0) => {
  const i = Math.max(t - e, 0), o = Math.max(t - n, 0);
  return rn(
    r,
    i,
    o
  );
};
function Oi(e, t) {
  if (e)
    switch (t) {
      case Y.CEIL:
        return Ei;
      case Y.FLOOR:
        return Ci;
      case Y.HALF_EVEN:
        return Pt;
      default:
        return Pt;
    }
  else
    switch (t) {
      case Y.CEIL:
        return Ii;
      case Y.FLOOR:
        return Mi;
      case Y.HALF_EVEN:
        return wt;
      default:
        return wt;
    }
}
const Ti = {
  isoDate: "YYYY-MM-DD",
  isoDateTime: "iso",
  localDate: "MM/DD/YYYY",
  localDateTime: "MM/DD/YYYY hh:mm A",
  localeDate: "MMMM DD, YYYY",
  localeDateNoLeadingZero: "MMMM D, YYYY"
}, ha = (e, t, r = !1) => sn(e, t, {
  whole: !0,
  inclusive: r
});
function fr(e, t) {
  return an(e, t);
}
function ya(e) {
  return fr(e, "localDate");
}
function va(e) {
  return fr(e, "localeDate");
}
function ga(e, t, r) {
  const n = typeof r == "string" ? Ti[r] : void 0, i = typeof t == "string" ? dt(t, n) : dt(t), a = (() => {
    switch (e) {
      case "weekly":
        return i.add(7, "day");
      case "bi_weekly":
        return i.add(14, "day");
      case "monthly":
        return i.add(1, "month");
      case "yearly":
        return i.add(1, "year");
      default:
        return;
    }
  })();
  return typeof t == "string" ? a?.format(n) : a?.toDate();
}
const mr = 1, Pa = (e, t = mr) => {
  const r = e.document;
  return e.innerHeight + Math.ceil(e.scrollY) + t >= r.body.scrollHeight;
}, wa = (e, t = mr) => e.clientHeight + Math.ceil(e.scrollTop) + t >= e.scrollHeight, hr = () => !!window.opener, yr = () => window.parent !== window, Ye = () => hr() || yr();
function Sa(e) {
  return e.toLowerCase().replace("_", "-");
}
const Aa = (e, t = ".p-invalid") => {
  (e ?? document).querySelector(t)?.scrollIntoView({
    block: "center"
  });
}, Ra = () => {
  history.pushState(null, document.title, window.location.href);
}, v = k("provider", {
  state: () => ({
    currentProviderKey: void 0,
    primary: void 0,
    cascade: [],
    providers: {},
    openedPaymentPlan: void 0,
    viewedOffers: []
  }),
  getters: {
    applyResponses: (e) => {
      const t = st(e.providers);
      return at(t, "applyResponse").filter((r) => r != null);
    },
    currentProviderConfig: (e) => {
      const t = e.currentProviderKey;
      if (t != null)
        return e.providers[t]?.config ?? e.cascade.find((r) => r.providerKey === t);
    },
    preauthResponses: (e) => {
      const t = st(e.providers);
      return at(t, "preauthResponse").filter((r) => r != null);
    }
  },
  actions: {
    addDisclosures(e, t) {
      const r = this.requireProviderSession(e);
      r.disclosures = nn([...r.disclosures, t]);
    },
    findApplyResponse(e) {
      return this.requireProviderSession(e).applyResponse;
    },
    findDisclosures(e) {
      return this.requireProviderSession(e).disclosures ?? [];
    },
    findPreauthResponse(e) {
      return this.requireProviderSession(e).preauthResponse;
    },
    findProviderConfig(e) {
      return this.requireProviderSession(e).config;
    },
    findOverrides(e) {
      return this.requireProviderSession(e).overrides;
    },
    findPaymentPlan(e, t) {
      return this.findPaymentPlans(e).paymentPlans.find(
        (r) => r.providerPlanCode === t
      );
    },
    findPaymentPlans(e) {
      return this.requireProviderSession(e).paymentPlans ?? {
        paymentPlans: []
      };
    },
    findPurchaseDetails(e) {
      return this.requireProviderSession(e).purchaseDetails;
    },
    findResponseByMode(e, t) {
      return t == "full" ? this.findApplyResponse(e) : this.findPreauthResponse(e);
    },
    findStipulations(e) {
      return this.requireProviderSession(e).stipluations;
    },
    findTrustSessionId(e) {
      return this.requireProviderSession(e).trustSessionId;
    },
    initializeCascade(e) {
      this.cascade = e;
      for (const t of e) {
        const r = this.requireProviderSession(t.providerKey);
        r.config = t;
      }
    },
    initializeProvider(e) {
      const { providerKey: t, preauthResponse: r, applyResponse: n, paymentPlans: i } = e, o = this.requireProviderSession(t);
      r && (o.preauthResponse = r), n && (o.applyResponse = n), i?.length && (o.paymentPlans = {
        paymentPlans: i
      });
    },
    requireProviderSession(e) {
      let t = this.providers[e];
      return t == null && (t = {
        disclosures: [],
        providerKey: e,
        stipluations: []
      }, this.providers[e] = t), t.providerKey ??= e, t.config ??= this.cascade.find(
        (r) => r.providerKey === e
      ), t;
    },
    switchProvider(e) {
      this.currentProviderKey = e;
    },
    setTrustSessionId(e, t) {
      const r = this.requireProviderSession(e);
      r.trustSessionId = t;
    },
    setPaymentPlans(e, t) {
      const r = this.requireProviderSession(e);
      r.paymentPlans = t;
    },
    setPreauthResponse(e) {
      const { providerKey: t } = e, r = this.requireProviderSession(t);
      r.preauthResponse = e, r.stipluations = e.stipulations ?? [];
    },
    setApplyResponse(e) {
      const { providerKey: t } = e, r = this.requireProviderSession(t);
      r.applyResponse = e, r.stipluations = e.stipulations ?? [];
    },
    resetProvider(e) {
      delete this.providers[e];
    },
    setPurchaseDetails(e, t) {
      const r = this.requireProviderSession(e);
      r.purchaseDetails = t;
    },
    setStipulations(e, t) {
      const r = this.requireProviderSession(e);
      r.stipluations = t;
    },
    addOverrides(e, t) {
      const r = this.requireProviderSession(e);
      r.overrides = t;
    },
    addViewedOffer(e) {
      this.viewedOffers.push(e);
    },
    updateStipulation(e, t) {
      const r = this.requireProviderSession(e), n = r.stipluations.findIndex(
        (i) => i.id === t.id
      );
      n !== -1 && (r.stipluations[n] = t);
    }
  }
}), W = k("locale", {
  state: () => ({
    experienceType: void 0,
    group: "versatile",
    language: "en",
    theme: "versatile",
    state: void 0
  }),
  getters: {
    locale: (e) => `${e.group}_${e.language}`
  },
  actions: {
    doInitialize(e) {
      this.experienceType = e.experienceType, this.group = e.groupId, this.theme = e.themeId ?? e.groupId, this.state = e.merchant?.location?.address?.state;
    }
  }
}), w = k("application", {
  state: () => ({
    application: void 0,
    jointSelectionEnabled: void 0,
    originalApplication: void 0,
    applyMode: void 0,
    applyStage: void 0,
    primaryProviderApplyMode: void 0,
    previousResponses: [],
    selectedPlan: void 0,
    stipulations: [],
    payments: []
  }),
  getters: {
    previousLender: (e) => (
      /**
       * Find the provider response that caused the transition to
       * the current lender.
       *
       * @param currentLender
       */
      ((t) => e.previousResponses.find(
        ({ next: r }) => r?.provider?.providerKey === t
      )?.provider)
    ),
    currentProviderResponse: (e) => (t) => {
      const r = e.previousResponses.find(
        ({ provider: n }) => n?.providerKey === t
      );
      return r?.provider !== void 0 ? r : void 0;
    },
    previousProviderResponse: (e) => (t) => {
      const r = e.previousResponses.find(
        ({ next: n }) => n?.provider?.providerKey === t
      );
      return r?.provider !== void 0 ? r : void 0;
    }
  },
  actions: {
    switchApplyMode(e) {
      this.applyMode = e, this.applyStage = e;
    },
    setApplicationValues(e) {
      const t = this.application = this.application ?? {};
      for (const r in e)
        ct(t, r, e[r]);
      this.application = t;
    },
    getApplicationValue(e) {
      const t = this.application;
      return t ? Zt(t, e) : void 0;
    },
    setApplicationValue(e, t) {
      this.application = ct(this.application ?? {}, e, t);
    },
    addResponse(e) {
      e.provider && !e.provider.applicantType && (e.provider.applicantType = J.PRIMARY), this.previousResponses.push(e);
    },
    updateStipulation(e) {
      this.stipulations = this.stipulations.map((t) => t.id === e.id ? e : t);
    },
    addPayment(e) {
      this.payments.push(e);
    }
  }
}), O = k("session", {
  state: () => ({
    id: void 0,
    flowSessionId: void 0,
    flowType: void 0,
    environment: void 0,
    properties: {},
    status: "IDLE",
    testCase: void 0,
    testCases: [],
    timeout: {},
    extensions: [],
    resume: void 0,
    storefrontSdk: void 0
  }),
  getters: {
    sessionId: (e) => e.id,
    isActive: (e) => !!e.id && e.status === "ACTIVE",
    needsRestore: (e) => !!e.id && e.status === "RESTORE_NEEDED",
    timedout: (e) => e.status === "TIMED_OUT",
    property: (e) => (t) => e.properties[t],
    providerResume: (e) => {
      const t = e.resume;
      return t && "applicationId" in t ? t : void 0;
    },
    waterfallResume: (e) => {
      const t = e.resume;
      return t && "waterfallSessionId" in t ? t : void 0;
    }
  },
  actions: {
    doRestore(e) {
      this.id = e, this.status = "RESTORE_NEEDED";
    },
    doTimeout() {
      this.status = "TIMED_OUT";
    },
    doInitialize(e) {
      this.id = e.webSessionId, this.environment = e.environment, this.flowSessionId = e.flowSessionId, this.flowType = e.flowType, this.properties = e.properties, this.testCases = e.testCases ?? [], this.testCase = void 0, this.extensions = e.extensions || [], this.storefrontSdk = e.storefrontSdk, this.timeout = {
        timeoutAfterMillis: e.sessionTimeoutMillis,
        warnAfterMillis: Math.max(
          0,
          e.sessionTimeoutMillis - e.sessionWarnCountdownMillis
        )
      }, this.resume = e.resume, this.status = "ACTIVE";
    },
    findExtensionsByFlowPosition(e) {
      return this.extensions.filter((t) => {
        let r = !1;
        return t.featureId == "prove" && (r = t.properties.skipUi), t.flowPosition == e && !r;
      });
    },
    findExtensionById(e) {
      return this.extensions.find(
        (t) => t.featureId === e
      );
    },
    updateResume(e) {
      this.resume = e;
    }
  }
}), vr = "vst.appState", St = () => {
  Object.keys(sessionStorage).forEach((e) => {
    e.startsWith(vr) && sessionStorage.removeItem(e);
  });
}, _i = async (e, t) => {
  const r = e.$state, n = await pr(t), i = Ai(), a = {
    state: await Ri(JSON.stringify(r), n, i),
    iv: Me.toString(i.buffer)
  };
  sessionStorage.setItem(Ve(e), JSON.stringify(a));
}, Di = async (e, t) => {
  const r = sessionStorage.getItem(Ve(e));
  if (!r)
    throw new Error(`Unable to find ${Ve(e)} in session store`);
  try {
    const n = JSON.parse(r), i = Me.toBinary(n.iv), o = await pr(t), a = await bi(n.state, o, i), s = JSON.parse(a);
    e.$patch(s), await L();
  } catch (n) {
    throw new Error(`Unable to read app state from session storage - ${n}`);
  }
};
function Ve(e) {
  return `${vr}.${e.$id}`;
}
const We = k("error", {
  state: () => ({
    error: void 0,
    info: void 0
  })
}), j = k("field", {
  state: () => ({
    fields: {},
    fieldArray: [],
    fieldsById: {},
    fieldGroupRules: [],
    fieldProviderKeys: []
  }),
  getters: {
    fieldByPath: (e) => (t) => e.fields[t],
    fieldById: (e) => (t) => e.fieldsById[t],
    fieldCount: (e) => Ue(e.fields).length
  },
  actions: {
    addFields(e) {
      const t = /* @__PURE__ */ new Set(), r = [];
      this.fieldArray.forEach((n) => {
        t.add(n.id);
      }), e.forEach((n) => {
        this.fields[n.path] = n, this.fieldsById[n.id] = n, t.has(n.id) || r.push(n);
      }), r.length > 0 && this.fieldArray.push(...r);
    },
    setFields(e) {
      this.fields = {}, this.fieldArray = e, this.fieldsById = {}, e.forEach((t) => {
        this.fields[t.path] = t, this.fieldsById[t.id] = t;
      });
    },
    getFieldsByPath(...e) {
      const t = [];
      return e.forEach((r) => {
        const n = this.fieldByPath(r);
        n && t.push(n);
      }), t;
    },
    removeFieldsByPath(...e) {
      e.forEach((t) => {
        const r = this.fieldByPath(t);
        r && (delete this.fields[r.path], delete this.fieldsById[r.id]);
      });
    }
  }
}), Je = k("merchant", {
  state: () => ({
    legalName: void 0,
    location: void 0,
    name: void 0,
    supportPhoneNumber: void 0,
    logoConfig: void 0,
    splashConfig: void 0,
    siteConfig: void 0
  }),
  actions: {
    doInitialize(e) {
      this.name = e.merchant?.name, this.legalName = e.merchant?.legalName, this.location = e.merchant?.location, this.logoConfig = e.merchant?.logoConfig, this.splashConfig = e.merchant?.splashConfig, this.supportPhoneNumber = e.merchant?.supportPhoneNumber, this.siteConfig = e.merchant?.siteConfig;
    }
  }
}), ba = k("navigation", {
  state: () => ({
    backPosition: void 0
  })
}), _ = k("app", {
  getters: {
    applyMode() {
      return w().applyMode;
    },
    currentProviderKey() {
      return v().currentProviderKey;
    },
    flowSessionId() {
      return O().flowSessionId;
    },
    group() {
      return W().group;
    },
    applyResponse() {
      const e = v();
      return (t) => e.findApplyResponse(t);
    },
    preauthResponse() {
      const e = v();
      return (t) => e.findPreauthResponse(t);
    }
  },
  actions: {
    resetAll() {
      const e = Ae();
      if (!e)
        throw new Error("There is no active Pinia instance");
      e._s.forEach((t) => {
        ["merchant", "locale"].includes(t.$id) || t.$reset();
      }), St();
    },
    clearedStoredAppStates() {
      St();
    },
    async persistStoreToSession(e) {
      const t = Ae();
      if (!t)
        throw new Error("There is no active Pinia instance");
      for (const r of t._s.values())
        await _i(r, e);
    },
    async reloadStoreFromSession(e) {
      const t = Ae();
      if (!t)
        throw new Error("There is no active Pinia instance");
      for (const r of t._s.values())
        await Di(r, e);
    }
  }
}), Fi = () => {
  const e = Ae();
  if (!e)
    throw new Error("Unable to find Active Pinia!");
  e.use(
    yn({
      key: (t) => `__persisted__${t}`,
      storage: window.sessionStorage,
      auto: !0
    })
  );
}, Ea = (e, t) => {
  const r = _(), n = rr(e, t);
  return r.$onAction((i) => {
    i.name === "resetAll" && n.clear();
  }), n;
}, Ca = (e, t = {}) => {
  const r = new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: t.minimumFractionDigits ?? 2,
    maximumFractionDigits: t.maximumFractionDigits ?? 2
  }), n = typeof e == "string" ? parseFloat(e) : e;
  return r.format(n > 1 ? n / 100 : n);
}, Ia = (e) => Promise.reject(new Error(e)), At = /* @__PURE__ */ Object.create(null);
function Ma(e, t) {
  if (!t)
    return e;
  const r = {};
  Object.keys(t).forEach((n) => {
    const i = t[n];
    typeof i == "number" ? r[n] = String(i) : Array.isArray(i) ? r[n] = i.map((o) => o.toString()) : i != null && (r[n] = i);
  });
  try {
    const n = At[e] || (At[e] = vn(e));
    return typeof t.pathMatch == "string" && (t[0] = t.pathMatch), n(r);
  } catch {
    return "";
  } finally {
    delete t[0];
  }
}
const Oa = (e, t, r = 0, n = e?.length, i) => e && Ni(e, t, r, n ?? e.length, i), Ni = (e, t, r = 0, n = e.length, i) => {
  if (e = e ?? "", r < 0 && (r = e.length + r), n < 0 && (n = e.length + n), r < 0 && (r = 0), (n < 0 || n > e.length) && (n = e.length), r >= e.length)
    return e;
  const o = e.split("");
  for (let a = r; a < n; a++)
    i?.test(o[a]) || (o[a] = t);
  return o.join("");
}, Rt = (e) => e == null ? !0 : typeof e == "string" ? e.trim().length === 0 : !1, Ta = (e = "Not implemented") => {
  throw new Error("TODO: " + e);
}, gr = () => {
  let e = (/* @__PURE__ */ new Date()).getTime(), t = performance?.now && performance.now() * 1e3 || 0;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(r) {
    let n = Math.random() * 16;
    return e > 0 ? (n = (e + n) % 16 | 0, e = Math.floor(e / 16)) : (n = (t + n) % 16 | 0, t = Math.floor(t / 16)), (r === "x" ? n : n & 3 | 8).toString(16);
  });
}, _a = (e) => {
  if (e == null || /[^0-9-\s]+/.test(e))
    return !1;
  switch (e.substring(0, 1)) {
    case "3":
      return Li(e);
    case "4":
      return xi(e);
    case "5":
      return Ki(e);
    case "6":
      return Ui(e);
    default:
      return pe(e);
  }
}, xi = (e) => e.length === 16 && pe(e), Li = (e) => e.length === 15 && pe(e), Ki = (e) => e.length === 16 && pe(e), Ui = (e) => e.length === 16 && pe(e), pe = (e) => {
  let t = 0, r = 0, n = !1;
  for (let i = e.length - 1; i >= 0; i--) {
    const o = e.charAt(i);
    r = parseInt(o, 10), n && (r *= 2) > 9 && (r -= 9), t += r, n = !n;
  }
  return t % 10 === 0;
}, fe = (e, t) => (t && (t.value = !1), async (...r) => {
  try {
    return t && (t.value = !0), await e(...r);
  } finally {
    t && (t.value = !1);
  }
});
var T = /* @__PURE__ */ ((e) => (e[e.TRACE = 0] = "TRACE", e[e.DEBUG = 1] = "DEBUG", e[e.INFO = 2] = "INFO", e[e.WARN = 3] = "WARN", e[e.ERROR = 4] = "ERROR", e))(T || {});
const Bi = (e) => {
  if (e.stack) {
    const t = e.stack.split(`
`), r = t[0]?.startsWith("Error") ? 4 : 3, n = t[r];
    if (n != null)
      return n.trim().replace("(", "").replace(")", "");
  }
}, ki = (e) => {
  if (e.includes("at "))
    return e.substring(e.indexOf("at ") + 3, e.lastIndexOf(" ")).split(".").reverse()[0];
  if (e.includes("@"))
    return e.substring(0, e.indexOf("@"));
}, qi = (e) => {
  const t = e.split(":").reverse(), r = t[2];
  if (r == null)
    return;
  const n = r.substring(
    Math.max(
      r.lastIndexOf("/"),
      r.lastIndexOf("\\")
    ) + 1
  ).split("?")[0], i = t[1];
  return {
    fileName: n,
    lineNumber: i
  };
};
class Gi {
  constructor(t, r, n) {
    this._name = t, this._isProduction = r, this._appenders = n;
  }
  _name;
  _isProduction;
  _appenders;
  trace(t, ...r) {
    this.log(T.TRACE, t, r);
  }
  debug(t, ...r) {
    this.log(T.DEBUG, t, r);
  }
  info(t, ...r) {
    this.log(T.INFO, t, r);
  }
  warn(t, ...r) {
    this.log(T.WARN, t, r);
  }
  error(t, ...r) {
    this.log(T.ERROR, t, r);
  }
  getCallerInfo() {
    const t = new Error();
    if (!t.stack)
      try {
        throw t;
      } catch {
      }
    if (t.stack)
      try {
        const r = Bi(t);
        if (r == null)
          return;
        const n = ki(r), i = qi(r);
        return {
          functionName: n,
          fileName: i?.fileName,
          lineNumber: i?.lineNumber
        };
      } catch (r) {
        f(this._isProduction) && console.debug(
          "vue-logger-plugin :: failed to determine caller function info:",
          r
        );
      }
  }
  log(t, r, n) {
    const i = [r, ...n], o = this.getCallerInfo();
    o && i.unshift(
      `[${o.fileName}:${o.functionName}:${o.lineNumber}]`
    ), this.append({
      name: f(this._name),
      level: t,
      args: i,
      caller: o
    });
  }
  append(t) {
    this._appenders.forEach((r) => r.append(t));
  }
}
class $i {
  append(t) {
    switch (t.level) {
      case T.TRACE:
        console.trace(t.name, ...t.args);
        break;
      case T.DEBUG:
        console.debug(t.name, ...t.args);
        break;
      case T.INFO:
        console.info(t.name, ...t.args);
        break;
      case T.WARN:
        console.warn(t.name, ...t.args);
        break;
      case T.ERROR:
        console.error(t.name, ...t.args);
        break;
    }
  }
}
class Vi {
  _client;
  _store;
  constructor(t, r) {
    this._client = t, this._store = r;
  }
  append(t) {
    this._client.log({
      clientDateTime: (/* @__PURE__ */ new Date()).toISOString(),
      level: this.buildLevel(t),
      message: this.buildMessage(t),
      name: t.name,
      source: "versatile-credit-apply",
      tags: this.buildTags()
    }).catch((r) => {
      console.error(r);
    });
  }
  buildTags() {
    const t = [], r = this._store.group;
    r && t.push(`[group=${r}]`);
    const n = this._store.currentProviderKey;
    n && t.push(`[providerKey=${n}]`);
    const i = this._store.applyMode;
    return i && t.push(`[applyMode=${i}]`), t.filter((o) => o !== "");
  }
  buildLevel(t) {
    switch (t.level) {
      case T.TRACE:
        return ae.TRACE;
      case T.DEBUG:
        return ae.DEBUG;
      case T.INFO:
        return ae.INFO;
      case T.WARN:
        return ae.WARN;
      case T.ERROR:
        return ae.ERROR;
    }
  }
  buildMessage(t) {
    let r = "";
    return t.args.forEach((n) => {
      r += " " + this.argToString(n);
    }), r.trim();
  }
  argToString(t) {
    return t instanceof Error ? t.message : typeof t == "object" ? JSON.stringify(t) : String(t);
  }
}
class H {
  store;
  constructor(t) {
    this.store = t;
  }
  get applyMode() {
    const t = this.store.applyMode;
    if (!t)
      throw new Error("Invalid Application State");
    return t;
  }
  get providerModule() {
    return K(this.provider);
  }
  get provider() {
    const t = this.store.currentProviderKey;
    if (!t)
      throw new Error("Invalid Application State");
    return t;
  }
  get providerKey() {
    return x(this.provider);
  }
}
class Wi extends H {
  client;
  constructor(t, r) {
    super(r), this.client = t;
  }
  async getQuiz() {
    const t = await this.client.loadQuiz(this.provider);
    return t.questions = lt(t.questions || [], ["sequence"]), t.questions.forEach((r) => {
      r.choices = lt(r.choices || [], ["sequence"]);
    }), t;
  }
  answerQuiz(t) {
    return this.client.answerQuiz(this.provider, t);
  }
  lookupApplication() {
    return this.client.checkApplication(this.provider);
  }
}
class Pr extends H {
  client;
  constructor(t, r) {
    super(r), this.client = t;
  }
  async sendVerificationCode(t, r) {
    return await this.client.sendVerificationCode(
      r ?? this.provider,
      t
    );
  }
  async verifyVerificationCode(t, r) {
    return await this.client.verifyVerificationCode(
      r ?? this.provider,
      t
    );
  }
}
const Oe = () => {
  const e = _(), t = b(
    () => `ApplicationService [${e.currentProviderKey}]`
  );
  return new ee(g(), e, t);
}, ne = () => {
  const e = v();
  return m(() => e.currentProviderKey);
}, wr = () => {
  const e = ne();
  return m(() => {
    const t = e.value;
    if (!t)
      throw Error("Provider is not set in the store!");
    return t;
  });
}, Da = (e) => {
  const t = ne(), r = () => e ? f(e) : void 0;
  return m(() => {
    const n = r() ?? t.value;
    return n ? x(n) : void 0;
  });
}, Fa = () => {
  const e = v(), t = wr(), r = m(() => e.cascade || []), n = m(
    () => r.value.find(
      (i) => x(i.providerKey) === x(t.value)
    )
  );
  return m(() => {
    if (!n.value)
      return !1;
    const i = r.value.indexOf(
      n.value
    );
    return i > -1 && i < r.value.length - 1;
  });
};
function Sr(e) {
  const t = v();
  return m(() => {
    const r = f(e);
    if (!r)
      return;
    const n = t.currentProviderKey;
    return r === n ? t.currentProviderConfig : t.findProviderConfig(r);
  });
}
const Na = () => {
  const e = ne();
  return Sr(e);
}, xa = () => {
  const e = j();
  return m(() => e.fieldGroupRules);
}, La = (e) => {
  const t = j();
  return m(() => {
    const r = f(e);
    return r ? t.fieldByPath(r) : void 0;
  });
}, ji = () => {
  const e = g();
  return (t) => e.getInvalidFields([f(t)]);
}, Ka = (e) => {
  const t = j();
  return m(() => t.fieldByPath(f(e)) != null);
}, we = (e) => {
  const t = e.id.lastIndexOf(".");
  return t === -1 ? e.id : e.id.substring(0, t);
}, Hi = (e, t) => t?.waterfallStatus !== "completed" || t.waterfallOutcomeType !== "offer_present" && t.waterfallOutcomeType !== "additional_info_required" ? !1 : t.waterfallProviderKey === e, zi = (e, t) => t.findIndex((r) => r.endsWith(".*") ? e.path.startsWith(r.substring(0, r.length - 2)) : e.path === r) > -1, Yi = (e, t, r) => {
  const n = on(t, (a) => a.path), i = /* @__PURE__ */ new Set();
  return t.forEach((a) => {
    a.rules.forEach((s) => {
      if (s.id === "requiredIf") {
        const c = e.find(({ id: l }) => l == s.fieldId);
        c != null && we(a) == we(c) && i.add(c.id);
      }
      s.id === "requiredIfNotNullIn" && s.fieldDescriptors.forEach((c) => {
        we(a) == we(c) && i.add(c.id);
      });
    });
  }), [...e.filter((a) => n[a.path] == null).filter(
    (a) => i.has(a.id) || zi(a, r)
  ), ...t];
}, Ua = () => {
  const e = ji(), t = w(), r = v(), n = O(), i = j();
  return async (o, a) => {
    const s = f(o), c = t.previousResponses.length > 0, l = !!r.findPreauthResponse(s);
    if (c || l || Hi(f(o), n.waterfallResume)) {
      const d = await e(o);
      i.setFields(
        Yi(i.fieldArray, d.fields, a || [])
      ), i.fieldGroupRules = d.fieldGroupRules, i.fieldProviderKeys = [f(o)];
    }
    return i.fieldCount > 0;
  };
}, Ji = (e) => m(() => {
  const t = f(e);
  return t ? K(t) : void 0;
}), Ar = (e = {}) => {
  const t = w(), r = v(), n = j();
  return (i) => (t.switchApplyMode(i.applyMode), n.setFields(i.fields), n.fieldGroupRules = i.fieldGroupRules, n.fieldProviderKeys = i.fieldProviderKeys, r.currentProviderKey = i.providerKey, e.overwriteCascade && r.initializeCascade(i.providers), r.primary?.providerKey === i.providerKey && (t.primaryProviderApplyMode = i.applyMode), new Qi(i.providerKey, !1));
}, Qe = () => {
  const e = b("useSwitchProvider"), t = g(), r = Ar();
  return async (n) => {
    const { providerKey: i, applyMode: o } = n;
    e.info(
      `Switching to provider: ${i} and apply mode: ${o}`
    );
    const a = await t.startProviderApply(i, o);
    return r(a);
  };
};
class Qi {
  constructor(t, r) {
    this._providerKey = t, this._resume = r;
  }
  _providerKey;
  _resume;
  get providerKey() {
    return this._providerKey;
  }
  get resume() {
    return this._resume;
  }
}
const Ba = () => new V(
  g(),
  _(),
  Oe(),
  Ar()
), ka = () => new To(g(), _()), qa = () => {
  const e = g(), t = _();
  return new _o(e, t);
}, Ga = () => {
  const e = g(), t = _();
  return new Do(e, t);
}, $a = () => new Oo(g()), Rr = () => new Pr(g(), _()), Zi = () => {
  const e = _();
  return new Re(g(), e);
}, Va = () => {
  const e = g(), t = v();
  return async (r, n) => {
    const { status: i } = await e.getProviderStipulationStatus(
      r,
      n.id
    );
    t.updateStipulation(r, {
      ...n,
      status: i
    });
  };
}, Xi = (e, t, r) => {
  te().reportCustomError(e, t, r, !0);
}, B = (e) => {
  if (e == null)
    return;
  const t = te();
  (e instanceof Error || typeof e == "string") && t.reportError(e);
}, eo = (e) => {
  const t = w();
  return m(() => {
    const r = f(e), n = t.application;
    return r === J.PRIMARY ? n?.primary : n?.joint;
  });
}, Wa = (e, t) => {
  const r = g(), n = b("useApplicationDocuments"), i = async () => {
    const d = f(e), u = f(t) ?? [];
    return d ? (await r.getApplicationDocuments(
      d,
      ...u
    )).documents.reduce(
      (P, A) => ({ ...P, [A.type]: A }),
      {}
    ) : {};
  }, { error: o, isLoading: a, isReady: s, state: c, execute: l } = ue(
    i,
    {},
    {
      onError: (d) => n.error(
        `Failed trying to fetch application documents for provider: ${f(e)}`,
        d
      )
    }
  );
  return {
    error: o,
    isLoading: a,
    isReady: s,
    state: c,
    refresh: l
  };
}, ja = () => {
  const e = b("use-complete-esign.ts"), t = Oe();
  return () => (e.info("Completing Esign"), t.completeEsign());
}, Ha = () => {
  const e = g();
  return {
    confirmSelectedPlan: async (r, n) => e.confirmPaymentPlan(r, n)
  };
}, to = (e) => {
  const t = v(), r = ne();
  return m(() => {
    const n = f(e) ?? r.value;
    return n ? t.findApplyResponse(n) ?? t.findPreauthResponse(n) : void 0;
  });
}, ro = () => {
  const e = w();
  return m(() => e.application?.downPaymentAmountCents ?? void 0);
}, no = (e, t) => {
  const r = w(), n = v(), i = () => {
    const o = f(e), a = x(o);
    return a === "fortiva_standard" ? n.findApplyResponse(o) ? "agreement" : "credit_terms" : a === "hfd_standard" ? "esignDoc" : r.applyMode ?? "full";
  };
  return m(() => (t ? f(t).documentType : void 0) ?? i());
}, io = (e) => m(() => {
  switch (e ? f(e).contentType : void 0) {
    case "gif":
      return "image/gif";
    case "jpeg":
      return "image/jpeg";
    case "png":
      return "image/png";
    case "pdf":
      return "application/pdf";
    case "html":
      return "text/html";
    case "text":
      return "text/plain";
    default:
      return;
  }
}), oo = (e) => {
  const t = g(), r = io(e);
  return m(() => {
    const n = {
      sid: t.sessionId ?? ""
    };
    return r.value && (n.contentType = r.value), new URLSearchParams(n).toString();
  });
}, za = (e, t) => {
  const r = g(), n = no(e, t), i = oo(t);
  return m(() => {
    const o = f(e), a = x(o), s = `${r.baseUrl}/api/v1/providers/${encodeURIComponent(o)}`;
    return a === "fortiva_standard" ? `${s}/documents/${n.value}?${i.value}` : `${s}/application/terms/${n.value}?${i.value}`;
  });
}, Ya = () => {
  const e = w();
  return m(() => e.application?.installationAddressSameAsPrimary ? e.application?.primary?.homeAddress : e.application?.installationLocation?.address);
};
function Ja() {
  const e = w();
  return m(() => !!Xt(e.previousResponses)?.next?.topoff?.amountCents);
}
const Qa = () => {
  const e = w(), t = v();
  return m(() => {
    const r = Xt(e.previousResponses)?.next;
    return r?.provider?.providerKey === t.currentProviderKey ? void 0 : r;
  });
}, Za = () => {
  const e = g(), t = b("useOfferLookup"), r = async () => {
    const l = f(so());
    return await e.offerLookup(l);
  }, { error: n, isLoading: i, isReady: o, state: a, execute: s, executeImmediate: c } = ue(
    r,
    {},
    {
      immediate: !1,
      onError: (l) => {
        t.error("Offers not found ", l);
      }
    }
  );
  return {
    error: n,
    isLoading: i,
    isReady: o,
    state: a,
    refresh: s,
    submit: c
  };
}, so = () => {
  const e = w();
  return {
    primary: {
      firstName: e.getApplicationValue("primary.firstName"),
      lastName: e.getApplicationValue("primary.lastName"),
      dateOfBirth: e.getApplicationValue("primary.dateOfBirth"),
      ssn: e.getApplicationValue("primary.ssn"),
      mobilePhone: e.getApplicationValue("primary.mobilePhone")
    }
  };
}, Xa = () => {
  const e = b("use-patch-application.ts"), t = Oe();
  return () => (e.info("Patching Application"), t.patchApplication());
}, ec = (e) => {
  const t = v(), r = ne();
  return m(() => {
    const n = f(e) ?? r.value;
    return n ? t.findPreauthResponse(n) : void 0;
  });
}, de = (e) => {
  const t = w(), r = v();
  return m({
    get: () => {
      const n = f(e);
      if (n) {
        const i = r.findOverrides(n);
        if (i?.purchaseAmountCents)
          return i.purchaseAmountCents;
      }
      return t.application?.purchaseAmountCents ?? void 0;
    },
    set: (n) => {
      const i = f(e);
      if (i) {
        const o = r.findOverrides(i);
        r.addOverrides(i, {
          ...o,
          purchaseAmountCents: n
        });
        return;
      }
      t.application && (t.application.purchaseAmountCents = n);
    }
  });
}, tc = () => {
  const e = g();
  return async (t) => e.publishUserOptOutProviderBypass(t);
}, rc = () => {
  const e = g();
  return async () => e.publishCascadeConsent({});
};
function nc(e) {
  if (e.standard)
    return {
      type: "link",
      value: e.href,
      params: {}
    };
  const t = e.protocol, r = ao(e.searchParams);
  return t === "route:" ? {
    type: "route",
    value: e.pathname,
    params: r
  } : {
    type: t + e.pathname,
    value: e.pathname,
    params: r
  };
}
function ao(e) {
  const t = {};
  return e.forEach((r, n) => {
    t[n] = r;
  }), t;
}
const co = (e) => ({
  type: "checkout.transition",
  data: {
    applicationId: e.applicationId,
    resume: e.applicationWasResumed,
    token: e.token,
    from: "apply"
  },
  source: "vcredit"
}), lo = (e) => ({
  type: "start",
  data: {
    flowId: e.flow
  },
  source: "vcredit"
}), uo = (e) => {
  const t = () => {
    switch (e.outcome) {
      case "completed":
      case "pending":
        return "completed";
      case "canceled":
        return "canceled";
      case "timeout":
        return "abandoned";
    }
  };
  return {
    type: "end",
    data: {
      flowId: e.flow,
      exitStatus: t()
    },
    source: "vcredit"
  };
}, po = (e) => ({
  type: "error",
  data: {
    category: e.category,
    cloudRequestId: e.cloudRequestId,
    code: e.code,
    message: e.message,
    httpStatusCode: e.httpStatusCode,
    httpMethod: e.httpMethod?.toLowerCase(),
    path: e.path
  },
  source: "vcredit"
}), fo = (e) => {
  const r = w().application, i = v().findProviderConfig(e.response.providerKey), o = () => i?.providerProduct?.replace(/-/g, "_")?.toLowerCase(), a = () => {
    switch (i?.providerProductType) {
      case "credit":
        return "revolving_credit";
      case "lease":
        return "lease";
      case "loan":
        return "loan";
      default:
        return;
    }
  }, s = () => {
    switch (e.response.responseCode) {
      case p.OPEN:
      case p.APPROVED:
        return "approved";
      case p.NOOFFER:
        return "nooffer";
      case p.DECLINED:
        return "declined";
      case p.ERROR:
        return "error";
      case p.PENDING:
      case p.SUBMITTED:
        return "pending";
      case p.PREAPPROVED:
      case p.PREQUALIFIED:
        return "prequalified";
    }
  };
  return {
    type: "application.decision",
    // @ts-expect-error need to populate metadata
    data: {
      sessionId: e.sessionId,
      agreedToCascade: r?.hasAgreedToCascade,
      amount: e.response.approvedAmountCents,
      applicationId: e.response.versatileApplicationId,
      accountId: e.response.versatileAccountId,
      status: s(),
      providerId: e.response.providerId,
      providerReferenceNumber: e.response.applicationId ?? e.response.applicationReferenceNumber,
      providerProductId: o(),
      productType: a(),
      message: e.response.errors?.[0]?.errorMessage
    },
    source: "vcredit"
  };
}, mo = (e) => ({
  type: "page.view",
  data: {
    path: e.toUrl
  },
  source: "vcredit"
}), ho = (e) => {
  switch (e.type) {
    case "checkout":
      return co(e);
    case "decision":
      return fo(e);
    case "end":
      return uo(e);
    case "error":
      return po(e);
    case "start":
      return lo(e);
    case "page-view":
      return mo(e);
    default:
      return;
  }
}, yo = (e) => (r) => {
  const n = ho(r);
  n && e.postMessage(n, "*");
}, vo = (e) => (t) => e.info("Event:", t), go = () => (e) => {
  const t = U.getInstance();
  switch (e.type) {
    case "start":
      t.push({
        event: "app.start",
        event_start_flow: e.flow
      });
      break;
    case "end":
      t.push({
        event: "app.end",
        event_end_flow: e.flow,
        event_end_outcome: e.outcome
      });
      break;
    case "error":
      t.push({
        event: "app.error",
        event_error_code: e.code,
        event_error_message: e.message,
        event_error_category: e.category
      });
      break;
    case "decision":
      t.push({
        event: "app.decision",
        event_decision_provider: e.response.providerId
      });
      break;
    case "checkout":
      t.push({
        event: "app.checkout"
      });
      break;
  }
}, Po = () => {
  const e = g(), t = O();
  return (r) => {
    t.isActive && r.type === "page-view" && e.publishSessionPageView({
      toUrl: r.toUrl,
      fromUrl: r.fromUrl
    }).catch((n) => B(n));
  };
}, wo = () => {
  const e = document.createElement("meta");
  return e.name = "session-id", document.head.appendChild(e), e;
}, bt = () => document.querySelector(
  "meta[name=session-id]"
) ?? wo(), So = () => {
  const e = O(), t = W();
  return (r) => {
    switch (r.type) {
      case "start": {
        Z(`vca.${r.type}`, {
          "app.session": e.flowSessionId,
          "app.group": t.group,
          "event.flow": r.flow
        });
        const n = bt();
        n.content = e.flowSessionId ?? "";
        break;
      }
      case "error": {
        Z(`vca.${r.type}`, {
          "app.session": e.flowSessionId,
          "app.group": t.group,
          "event.category": r.category,
          "event.code": r.code,
          "event.message": r.message,
          "event.request": r.cloudRequestId
        });
        break;
      }
      case "checkout": {
        Z(`vca.${r.type}`, {
          "app.session": e.flowSessionId,
          "app.group": t.group,
          "event.application": r.applicationId,
          "event.resumed": r.applicationWasResumed
        });
        break;
      }
      case "decision": {
        Z(
          `vca.${r.type}.${r.response.responseCode}`,
          {
            "app.session": e.flowSessionId,
            "app.group": t.group,
            "event.provider": r.response.providerId,
            "event.provider.key": r.response.providerKey,
            "event.application": r.response.versatileApplicationId,
            "event.approved-amount-cents": r.response.approvedAmountCents ?? 0,
            "event.apr": r.response.apr
          }
        );
        break;
      }
      case "page-view": {
        Z(`vca.${r.type}`, {
          "app.session": e.flowSessionId,
          "app.group": t.group,
          "event.from": r.fromUrl,
          "event.to": r.toUrl
        });
        break;
      }
      case "end": {
        Z(`vca.${r.type}`, {
          "app.session": e.flowSessionId,
          "app.group": t.group,
          "event.flow": r.flow,
          "event.outcome": r.outcome
        });
        const n = bt();
        n.content = "";
        break;
      }
    }
  };
}, Ao = () => {
  const e = Ur(), t = [
    So(),
    Po(),
    go()
  ];
  if (Ye() && t.push(yo(window.opener ?? window.parent)), e.mode === "development") {
    const r = b("LoggingEventPublisher");
    t.push(vo(r));
  }
  return t;
}, re = () => {
  const e = Ao();
  return (t) => e.forEach((r) => r(t));
}, Ro = (e) => {
  const t = v(), r = w();
  return async (n) => {
    const i = n.getResponseToContinueWith();
    if (i && i.provider)
      t.switchProvider(i.provider.providerKey), r.switchApplyMode(i.applyMode), await L(), await e.presentMultipleOffers(n);
    else
      throw new Error("Unhandled Cascade response!");
  };
}, bo = (e) => {
  const t = Qe();
  return async (r) => {
    const n = r.nextProvider(), i = r.nextApplyMode();
    if (n && i)
      if (await t({
        providerKey: n,
        applyMode: i
      }), await L(), r.isResumingNextProvider()) {
        const o = r.getResponseForProvider(n);
        if (!o)
          throw new Error(
            "Response was not returned for the provider " + n
          );
        await e.presentDecision(
          new qe(n),
          o,
          r
        );
      } else
        await e.transitionTo(
          new qe(n),
          i,
          r
        );
    else
      throw new Error("Unhandled Cascade response!");
  };
}, br = (e) => {
  const t = v(), r = w();
  return async (n) => {
    const i = n.getResponseToContinueWith();
    if (i && i.provider) {
      const { providerKey: o } = i.provider;
      t.switchProvider(o), r.switchApplyMode(i.applyMode);
      const a = t.findProviderConfig(o);
      a && (i.provider.productType && (a.productType = i.provider.productType), i.provider.providerBankId && (a.providerBankId = i.provider.providerBankId)), await L(), await e.presentDecision(
        new qe(o),
        i,
        n
      );
    } else
      throw new Error("Unhandled Cascade response!");
  };
}, Eo = (e) => br(e), Co = () => {
  const e = O();
  return m(() => e.extensions.find(
    (r) => r.featureId === "hosted-flow"
  )?.properties);
}, Et = "vst.app_session", Io = () => {
  const e = Co(), t = O(), r = (a, s) => new Date(a.getTime() + s * 1e3);
  return {
    enabled: m(() => e.value !== null),
    clearSession: () => {
      ut.remove(Et);
    },
    persistSession: () => {
      e.value && t.flowSessionId && ut.set(Et, t.flowSessionId, {
        domain: e.value.cookieDomain,
        secure: !0,
        sameSite: "lax",
        expires: r(/* @__PURE__ */ new Date(), e.value.cookieDuration)
      });
    }
  };
}, ic = (e) => Mo(e, Ce.ACCEPT_OFFER), Mo = (e, t) => {
  const r = m(
    () => f(t) === Ce.ACCEPT_OFFER
  ), n = b(
    () => r.value ? "use-accept-offer.ts" : "use-submit-application.ts"
  ), i = O(), o = Oe(), a = br(e), s = Eo(e), c = bo(e), l = Ro(e), d = re(), u = Io(), C = (P) => {
    const A = i.flowSessionId;
    A && d({
      type: "decision",
      response: P,
      sessionId: A
    });
  };
  Jt(async () => {
    await L();
    let P;
    return r.value ? (n.info("Accepting Offer"), P = await o.acceptOffer()) : (n.info("Submitting Application"), P = await o.submitApplication()), P.allResponses.map((E) => E.provider).filter((E) => E != null).forEach(C), u.enabled.value && u.persistSession(), P.hasSingleOffer() ? (n.info("Handling Single Offer"), await s(P)) : P.hasMultipleOffers() ? (n.info("Handling Multiple Offers"), await l(P)) : f(e.canSwitchProviders ?? !0) && P.shouldSwitchProviders() ? (n.info("Handling Provider Transition"), await c(P)) : (n.info("Handling Standard Response"), await a(P));
  });
}, oc = (e) => {
  const t = g(), r = b("useApplicationProviderStatus");
  return un(async () => {
    try {
      return await t.getApplicationStatus(e);
    } catch {
      return r.error("Error getting application status"), null;
    }
  });
};
var Dt, Ft, Nt, xt, Lt, X;
class ee extends (Lt = H, xt = [F("Submit Application")], Nt = [F("Patch Application")], Ft = [F("Complete Esign")], Dt = [F("Accept Offer")], Lt) {
  constructor(r, n, i) {
    super(n);
    he(X, 5, this);
    z(this, "client");
    z(this, "logger");
    this.client = r, this.logger = i;
  }
  async submitApplication(r) {
    const n = new ye(this.provider, this.applyMode);
    switch (n.mode) {
      case "prescreen":
        await this.prescreen(n, r);
        break;
      case "prequalify":
        await this.prequalify(n, r);
        break;
      default:
        await this.apply(n, r);
    }
    return new ve(n);
  }
  async patchApplication() {
    const r = this.buildCreditApp();
    if (!r)
      throw new Error("Invalid application state");
    const n = {
      application: r
    }, i = await this.client.patch(this.provider, n);
    return i.provider && v().setPreauthResponse(i.provider), i;
  }
  async completeEsign() {
    const r = this.buildCreditApp();
    if (!r)
      throw new Error("Invalid application state");
    const n = {
      application: r,
      saveApplicationOnly: !1,
      sendWebhookUpdate: !0
    }, i = await this.client.patch(this.provider, n);
    return i.provider && v().setPreauthResponse(i.provider), i;
  }
  async acceptOffer() {
    const r = new ye(this.provider, this.applyMode);
    if (!this.buildCreditApp())
      throw new Error("Invalid application state");
    const i = async (o, a) => {
      let s = this.providerModule.asyncOfferAcceptance ? await this.client.submitApplication(this.provider, a) : await this.client.acceptOffer(this.provider, a);
      return s.provider?.responseCode === p.SUBMITTED && (s = await this.waitForOfferAcceptance(
        (/* @__PURE__ */ new Date()).getTime() + 6e4
      )), s.provider && (s.provider.operation = Ce.ACCEPT_OFFER), s;
    };
    return await this.execute(r, {}, i), new ve(r);
  }
  async addBankCard(r) {
    return await this.client.addBankCard(this.provider, r);
  }
  async addBankAccount(r) {
    return await this.client.addBankAccount(this.provider, r);
  }
  async initiateExternalApplication(r, n) {
    const i = await this.client.launchExternalApplication(
      r,
      n
    );
    if (!i.url)
      throw new Error("No redirect url received");
    const o = _(), a = o.flowSessionId;
    if (!a)
      throw new Error(
        "Unable to launch external application id without a sessionId"
      );
    await o.persistStoreToSession(a), this.logger.info(
      `Redirecting to external application URL - ${i.url}`
    ), window.location.href = i.url;
  }
  async addExternalResponse(r) {
    const n = new ye(
      this.provider,
      r.applyMode
    );
    return await this.execute(n, {}, async () => r), new ve(n);
  }
  async waitForOfferAcceptance(r) {
    this.logger.info("Checking status of offer acceptance:", this.provider);
    const n = await this.client.checkApplication(this.provider);
    if (!n.provider)
      throw new Error("Provider is missing from response");
    switch (n.provider.responseCode) {
      case p.SUBMITTED:
        if (r > (/* @__PURE__ */ new Date()).getTime())
          return ce(5e3, () => this.waitForOfferAcceptance(r));
        break;
      case p.APPROVED:
        if (this.providerModule.requiresAccountCreation)
          return this.client.createAccount(this.provider);
        break;
    }
    return n;
  }
  async waitForApplicationStatus(r) {
    this.logger.info("Checking status of application status:", this.provider);
    const n = await this.client.checkApplication(this.provider);
    if (!n.provider)
      throw new Error("Provider is missing from response");
    return r > (/* @__PURE__ */ new Date()).getTime() && n.provider.responseCode === p.SUBMITTED ? ce(5e3, () => this.waitForApplicationStatus(r)) : n;
  }
  async waitForPrequalifyStatus(r, n) {
    this.logger.info(
      "Checking status of prequalify application status:",
      r.provider
    ), K(r.provider).asyncPrequalifySubmissionRequiresRefresh && await this.client.refreshPrequalifyApplication(r.provider);
    const i = await this.client.checkPrequalifyApplication(
      r.provider
    );
    if (!i.provider)
      throw new Error("Provider is missing from response");
    return n > (/* @__PURE__ */ new Date()).getTime() && i.provider.responseCode === p.SUBMITTED ? ce(
      5e3,
      () => this.waitForPrequalifyStatus(r, n)
    ) : i;
  }
  async getIframeUrl() {
    return this.client.geIframeUrl(this.provider);
  }
  async getEsignIframeUrl(r) {
    return this.client.getEsignIframeUrl(this.provider, r);
  }
  async getEsignIframeUrlWithRedirect(r) {
    return this.client.getEsignIframeUrlWithRedirect(this.provider, r);
  }
  esignApplication(r = {}) {
    return this.providerKey === "aqua_standard" ? this.esignAquaApplication(r) : this.client.esign(this.provider, r);
  }
  // This is to workaround Aqua having a deadlock in their database.
  // Instead of them fixing their backend issues, they advised us to wait
  // and retry this.
  async esignAquaApplication(r) {
    let n = await this.client.esign(this.provider, r);
    if (n.responseCode === "error") {
      let i = 5;
      for (; i > 0 && n.responseCode === "error"; )
        this.logger.warn(
          `Retrying esign generation, previous attempt resulted in error, attempts remaining=${i}`
        ), n = await ce(
          3e4,
          () => this.client.esign(this.provider, r)
        ), i--;
    }
    return n.responseCode === "error" && this.logger.error(
      "Failed to esign application after repeated attempts with the lender"
    ), n;
  }
  async getEsignStatus() {
    return this.client.getEsignStatus(this.provider);
  }
  async getEsignStatuses() {
    return this.client.getEsignStatuses(this.provider);
  }
  async completeApplication() {
    return this.client.completeApplication(this.provider);
  }
  async paymentToken(r) {
    const n = w(), i = await this.client.paymentToken(this.provider, r);
    return (i.paymentToken || i.paymentType == "cash") && n.addPayment(i), i;
  }
  async hydrateProvider(r) {
    const n = w(), i = de(this.provider), o = v();
    if (this.isApproved(r.responseCode)) {
      const a = K(r.providerKey), { loadPaymentPlans: s, loadPurchaseDetails: c } = a.hydrationPostProcessing;
      if (s && this.shouldFetchPlans(r)) {
        const l = r.approvedAmountCents ?? 0, d = i.value ?? 0, u = Ee(
          l,
          d,
          n.application?.downPaymentAmountCents
        ), C = await this.client.getPaymentPlans(
          r.providerKey,
          d,
          u
        );
        o.setPaymentPlans(r.providerKey, C);
      }
      if (c) {
        const l = await this.client.getPurchaseDetails(
          r.providerKey
        );
        o.setPurchaseDetails(r.providerKey, l);
      }
    }
  }
  async continueCascade(r, n) {
    const i = new ye(this.provider, this.applyMode);
    return i.appendResponse(r), await this.handleResponse(i, n), new ve(i);
  }
  async prequalify(r, n) {
    const i = K(r.provider);
    i.asyncPrequalifySubmission ? await this.execute(r, n, async (o, a) => {
      const s = await this.client.prequalify(o, a);
      return s?.provider?.responseCode === p.SUBMITTED ? this.doAfterAsyncPrequalify(s.provider.providerKey) : s;
    }) : i.submitAfterPrequalify ? await this.execute(r, n, async (o, a) => {
      const s = await this.client.prequalify(o, a);
      return s?.provider?.responseCode === p.SUBMITTED ? await this.client.submitAfterPrequalify(o) : s;
    }) : await this.execute(
      r,
      n,
      this.client.prequalify.bind(this.client)
    );
  }
  async doAfterAsyncPrequalify(r) {
    const n = K(r), i = await this.pollForPrequalifyStatus(
      n,
      r,
      (/* @__PURE__ */ new Date()).getTime() + 9e4
    );
    return i.provider?.responseCode === p.PREQUALIFIED && n.refreshApplicationAfterPrequalified ? await this.client.checkApplication(r) : i;
  }
  async pollForPrequalifyStatus(r, n, i) {
    this.logger.info(
      "Checking status of prequalify application status:",
      n
    ), r.asyncPrequalifySubmissionRequiresRefresh && await this.client.refreshPrequalifyApplication(n);
    const o = await this.client.checkPrequalifyApplication(n);
    if (!o.provider)
      throw new Error("Provider is missing from response");
    return i > (/* @__PURE__ */ new Date()).getTime() && o.provider.responseCode === p.SUBMITTED ? ce(
      5e3,
      () => this.pollForPrequalifyStatus(r, n, i)
    ) : (o.provider.responseCode === p.SUBMITTED && (o.provider.responseCode = p.PENDING), o);
  }
  async handlePendingPrequalResume(r) {
    const n = r.providerKey, i = K(n);
    let o;
    if (i.asyncPrequalifySubmission ? o = await this.doAfterAsyncPrequalify(n) : i.submitAfterPrequalify && r?.responseCode === p.SUBMITTED ? o = await this.client.submitAfterPrequalify(n) : o = await this.client.checkPrequalifyApplication(n), !o.provider)
      throw new Error("Provider is missing from response");
    return v().setPreauthResponse(o.provider), o;
  }
  async rollbackLoan() {
    return this.client.rollbackLoan(this.provider);
  }
  async getDomainCategories(r) {
    return this.client.getDomainCategories(r);
  }
  async prescreen(r, n) {
    await this.execute(
      r,
      n,
      this.client.prescreen.bind(this.client)
    );
  }
  async apply(r, n) {
    this.providerModule.asyncApplicationSubmission ? await this.execute(r, n, async (i, o) => {
      const a = await this.client.submitApplication(
        i,
        o
      );
      return a?.provider?.responseCode === p.SUBMITTED ? this.waitForApplicationStatus(Date.now() + 4e4) : a;
    }) : await this.execute(r, n, this.client.apply.bind(this.client));
  }
  async execute(r, n = {}, i) {
    const o = this.buildCreditApp();
    if (!o)
      throw new Error("Invalid application state");
    const a = n.providerConfig ? n.providerConfig(r.provider) : void 0;
    this.addDeviceInfo(o), this.calculateIncome(o), this.setInstallationLocation(o);
    const s = v(), c = {
      application: o,
      autoSubmit: r.autoSubmit,
      returnUrl: a?.returnUrl,
      trustSessionId: s.findTrustSessionId(r.provider)
    };
    try {
      await r.execute((l) => i(l, c)), await this.handleResponse(r, n);
    } catch (l) {
      await this.handleError(r, l);
    }
  }
  async handleResponse(r, n) {
    const i = r.lastResponse;
    if (await this.storeResponse(r.provider, i), !i.provider) {
      const o = new Error("Unknown response, provider is missing");
      throw B(o), o;
    }
    if (i.provider?.responseCode === p.ERROR) {
      const o = i.provider;
      Xi(
        "provider_application_error",
        `${o.providerKey} ${o.operation} resulted in error`,
        `versatile application id: ${o.versatileApplicationId}`
      );
    }
    if (i.provider.responseCode === p.PREAPPROVED || i.provider.responseCode === p.PREQUALIFIED) {
      const o = w();
      o.applyStage = "offer";
    }
    i.next && await this.cascade(r, n);
  }
  async handleError(r, n) {
    if (B(n), n instanceof Ht)
      if (this.logger.error(
        `${r.provider} application contains validation errors`
      ), r.hasLastResponse()) {
        const i = r.lastResponse.next;
        if (i) {
          this.logger.info(`Forwarding cascade to start at ${r.provider}`), r.start = !0, i.validationError = n.error, i.autoSubmit = !1;
          return;
        }
      } else
        this.logger.warn(
          `Initial submission contained validation errors ${r.provider}, can't handle this here!`
        );
    throw this.logger.error(
      `FATAL: ${r.provider} application failed while submitting re-throwing`,
      n
    ), n;
  }
  async cascade(r, n) {
    if (!r.lastResponse.next)
      return;
    const i = r.lastResponse.next;
    if (i.resultType !== "provider") {
      this.logger.warn("Unknown resultType from Cascade", i.resultType);
      return;
    }
    if (r.autoSubmit = i.autoSubmit, !i.requireUserAction) {
      if (!i.autoSubmit) {
        r.start = !i.resume, r.resume = i.resume;
        return;
      }
      if (!i.topoff)
        switch (r.provider = i.provider.providerKey, r.mode = i.applyMode, i.applyMode) {
          case "prescreen":
            await this.prescreen(r, n);
            break;
          case "prequalify":
            await this.prequalify(r, n);
            break;
          default:
            await this.apply(r, n);
        }
    }
  }
  calculateIncome(r) {
    const n = r.primary?.income;
    n && this.normalizeIncome(n);
    const i = r.joint?.income;
    i && this.normalizeIncome(i);
  }
  addDeviceInfo(r) {
    if (r.device?.type != null)
      return;
    const n = fi().type, i = r.device;
    i == null ? r.device = {
      type: n
    } : i.type = n;
  }
  setInstallationLocation(r) {
    if (r.installationAddressSameAsPrimary) {
      const n = r.installationLocation;
      n && (n.address = r.primary?.homeAddress);
    }
  }
  normalizeIncome(r) {
    const n = r.grossAnnualCents, i = r.grossMonthlyCents;
    n != null && Rt(i) && (r.grossMonthlyCents = n / 12), i != null && Rt(n) && (r.grossAnnualCents = i * 12);
  }
  async storeResponse(r, n) {
    const i = w(), o = de(r);
    if (i.addResponse(n), n.provider) {
      const a = v();
      if (n.applyMode === "full" ? a.setApplyResponse(n.provider) : a.setPreauthResponse(n.provider), i.stipulations = n.session?.stipulations ?? [], this.shouldFetchPlans(n.provider)) {
        const s = n.provider.approvedAmountCents ?? 0, c = o.value ?? s, l = Ee(
          s,
          c,
          i.application?.downPaymentAmountCents
        ), d = await this.client.getPaymentPlans(
          r,
          c,
          l
        );
        a.setPaymentPlans(r, d);
      }
    }
  }
  isApproved(r) {
    return [
      p.PREQUALIFIED,
      p.PREAPPROVED,
      p.APPROVED
    ].includes(r);
  }
  shouldFetchPlans(r) {
    const n = K(r.providerId);
    return n.fetchPaymentPlansOnPreauthApproval && this.isPreApproved(r.responseCode) ? !0 : this.isApproved(r.responseCode) && n.fetchPaymentPlansOnApproval;
  }
  buildCreditApp() {
    const r = w();
    if (!r.application)
      return;
    const n = de(this.provider);
    return {
      ...r.application,
      purchaseAmountCents: n.value
    };
  }
  isPreApproved(r) {
    return [
      p.PREQUALIFIED,
      p.PREAPPROVED
    ].includes(r);
  }
}
X = me(Lt), D(X, 1, "submitApplication", xt, ee), D(X, 1, "patchApplication", Nt, ee), D(X, 1, "completeEsign", Ft, ee), D(X, 1, "acceptOffer", Dt, ee), se(X, ee);
var Kt, Ut, Bt, kt, qt, Gt, $t, $;
class V extends ($t = H, Gt = [F("Start Flow - Token")], qt = [F("Start Flow - Entity Key")], kt = [F("Start Flow - Default")], Bt = [F("Restart Flow")], Ut = [F("Restore Flow")], Kt = [F("Reevaluate Cascade")], $t) {
  constructor(r, n, i, o) {
    super(n);
    he($, 5, this);
    z(this, "client");
    z(this, "applicationService");
    z(this, "startProvider");
    this.client = r, this.applicationService = i, this.startProvider = o;
  }
  async startFlowWithToken(r, n) {
    return this.startFlow(() => this.client.startFlowWithToken(r), n);
  }
  async startFlowWithEntityKey(r, n = {}, i) {
    return this.startFlow(
      () => this.client.startFlowWithEntityKey(r, n),
      i
    );
  }
  async startFlowWithDefaultEntityKey(r) {
    return this.startFlow(
      () => this.client.startFlowWithDefaultEntityKey(),
      r
    );
  }
  async restartFlow(r) {
    const n = await this.client.restartFlow(), i = v();
    return n.providerConfigs.forEach((o) => {
      i.resetProvider(o.providerKey);
    }), this.startFlowWithResponse(n, r);
  }
  async restoreFlow(r, n) {
    return this.startFlowWithResponse(
      await this.client.restoreFlow(n),
      r
    );
  }
  async reevaluateCascade(r, n) {
    const i = await this.client.reevaluateCascade(r);
    return this.startFlowWithResponse(i, n);
  }
  async startFlow(r, n) {
    return this.store.resetAll(), this.startFlowWithResponse(await r(), n);
  }
  async startFlowWithResponse(r, n) {
    const i = te();
    switch (i.identify(r.flowSessionId), i.addStringActionProperty("flow-type", r.flowType), W().doInitialize(r), Je().doInitialize(r), O().doInitialize(r), r.flowType) {
      case "apply":
        return this.startApplyFlow(r, n);
      case "credit_limit_change":
        return this.startCreditLimitChangeFlow(r);
      case "pre_apply":
        return this.startPreApplyFlow(r);
      case "oh_my_bobs":
        return this.startBdfAssociateFlow(r);
      default:
        throw new Error(`Unsupported flow type: ${r.flowType}`);
    }
  }
  async startApplyFlow(r, n) {
    const i = w();
    if (i.application = structuredClone(r.application), i.originalApplication ??= structuredClone(
      r.application
    ), i.stipulations = r.sessionStipulations ?? [], !r.start.providers.length)
      throw new Error("Invalid Configuration - No providers are available.");
    const o = v();
    o.initializeCascade(r.start.providers), r.providerStates.length && r.providerStates.forEach(
      (d) => this.setupProviderState(r, d)
    ), i.primaryProviderApplyMode = r.start.applyMode, o.primary = r.start.providers[0];
    const a = this.startProvider(r.start);
    let s = !!r.resume, c = a.providerKey;
    const l = r.resume && "cascadeResponse" in r.resume ? r.resume.cascadeResponse : void 0;
    if (l) {
      i.addResponse({
        ...l,
        applyMode: r.start.applyMode
      });
      const d = await this.applicationService.continueCascade(
        l,
        n?.submitApp
      );
      s = !0, c = d.getResponseToContinueWith()?.provider?.providerKey ?? a.providerKey, this.resetStateAfterResume(o, c, r);
    }
    return {
      experienceType: r.experienceType,
      flowType: r.flowType,
      providerKey: c,
      resume: s
    };
  }
  startPreApplyFlow(r) {
    j().setFields(r.fields);
    const i = w();
    return i.originalApplication = structuredClone(r.application), {
      experienceType: r.experienceType,
      flowType: r.flowType,
      resume: !1
    };
  }
  startBdfAssociateFlow(r) {
    const n = w();
    return n.originalApplication = structuredClone(r.application), v().initializeCascade(r.providerConfigs), r.providerStates.length && r.providerStates.forEach(
      (o) => this.setupProviderState(r, o)
    ), {
      experienceType: r.experienceType,
      flowType: r.flowType,
      resume: !1
    };
  }
  startCreditLimitChangeFlow(r) {
    throw new Error("startCreditLimitChangeFlow not implemented.");
  }
  setupProviderState(r, n) {
    if (this.shouldIgnoreProviderState(r, n))
      return;
    v().initializeProvider(n);
  }
  resetStateAfterResume(r, n, i) {
    const o = i.providerStates.find(
      (a) => a.providerKey === n
    );
    o && this.shouldIgnoreProviderState(i, o) && r.resetProvider(n);
  }
  shouldIgnoreProviderState(r, n) {
    return !r.properties.resetToOffers || !n.applyResponse ? !1 : [
      p.PENDING,
      p.APPROVED,
      p.NOOFFER,
      p.DECLINED,
      p.SUBMITTED
    ].includes(n.applyResponse.responseCode);
  }
}
$ = me($t), D($, 1, "startFlowWithToken", Gt, V), D($, 1, "startFlowWithEntityKey", qt, V), D($, 1, "startFlowWithDefaultEntityKey", kt, V), D($, 1, "restartFlow", Bt, V), D($, 1, "restoreFlow", Ut, V), D($, 1, "reevaluateCascade", Kt, V), se($, V);
class Oo {
  client;
  constructor(t) {
    this.client = t;
  }
  async validateZipCode(t, r) {
    return (await this.client.validateZipCode({ state: t, zipCode: r })).valid;
  }
  async validatePhone(t) {
    return (await this.client.validatePhone({ phoneNumber: t })).valid;
  }
  async validateApplication(t, r) {
    const n = w();
    try {
      return await this.client.validateApplication({
        providerKeys: t,
        applicationData: n.application ?? {},
        fieldIds: r
      }), null;
    } catch (i) {
      if (i instanceof Ht)
        return i.error;
      throw i;
    }
  }
}
var Vt, Wt, jt, Se;
class Re extends (jt = H, Wt = [F("Select Payment Plans")], Vt = [F("Select Payment Plan")], jt) {
  constructor(r, n) {
    super(n);
    he(Se, 5, this);
    z(this, "client");
    this.client = r;
  }
  getPaymentPlans(r, n, i) {
    const o = te();
    return o.addStringActionProperty("providerKey", r), o.addNumberActionProperty("purchaseAmountCents", n), o.addNumberActionProperty(
      "downPaymentAmountCents",
      i ?? 0
    ), this.client.getPaymentPlans(
      r,
      n,
      i
    );
  }
  async selectPaymentPlan(r) {
    const n = this.store.applyMode;
    if (!n)
      throw new Error("Invalid application state. ApplyMode is not set!");
    const i = w(), a = v().findResponseByMode(
      r.providerKey,
      n
    );
    if (!a)
      throw new Error(
        `Unable to locate provider response for ${r.providerKey} and ${n}`
      );
    const s = i.application?.purchaseAmountCents, c = Ee(
      r.approvedAmountCents ?? a.approvedAmountCents ?? 0,
      s ?? 0,
      i.application?.downPaymentAmountCents
    ), l = te();
    l.addStringActionProperty("providerKey", r.providerKey), l.addStringActionProperty("providerPlanCode", r.providerPlanCode), l.addNumberActionProperty("financeAmountCents", s ?? 0), l.addNumberActionProperty(
      "downPaymentAmountCents",
      c ?? 0
    ), r.providerPlanId && l.addStringActionProperty("providerPlanId", r.providerPlanId);
    const d = {
      providerPlanCode: r.providerPlanCode,
      financeAmountCents: s,
      downPaymentAmountCents: c,
      offerId: r.providerPlanId,
      promotionalName: r.promotionalName
    };
    await this.client.selectPaymentPlan(r.providerKey, d), i.selectedPlan = r;
    const u = {
      providerKey: r.providerKey,
      paymentPlanCode: r.providerPlanCode
    };
    i.setApplicationValue("selectedOffer", u), i.setApplicationValue(
      "downPaymentAmountCents",
      c
    );
  }
  publishPlansPresented(r, n) {
    return this.client.publishPlansPresented({
      providerKeys: r,
      isSummary: n
    });
  }
  publishFinancingOptionSummaryPresented(r) {
    return this.client.publishFinancingOptionSummaryPresented(
      r
    );
  }
}
Se = me(jt), D(Se, 1, "getPaymentPlans", Wt, Re), D(Se, 1, "selectPaymentPlan", Vt, Re), se(Se, Re);
class To extends H {
  client;
  constructor(t, r) {
    super(r), this.client = t;
  }
  async refreshProviderStipulations(t) {
    const { stipulations: r } = await this.client.refreshStipulations(t);
    v().setStipulations(t, r);
  }
  async refreshSessionStipulationStatus(t) {
    const { status: r } = await this.client.getStipulationStatus(t.id);
    w().updateStipulation({
      ...t,
      status: r
    });
  }
  async uploadStipulationDocument(t, r, n) {
    const i = {
      stipulationId: r.id,
      document: n
    };
    return this.client.uploadStipulationDocument(t, i);
  }
}
class _o extends H {
  client;
  constructor(t, r) {
    super(r), this.client = t;
  }
  getApplyTermsUrl(t, r) {
    const n = this.provider, i = this.providerKey, o = this.client.baseUrl ?? "", a = this.client.sessionId ?? "", s = r ?? this.store.applyMode, c = {
      contentType: t,
      sid: a
    };
    switch (i) {
      case "fortiva_standard": {
        const d = v().findApplyResponse(i);
        return Pe(
          `${o}/api/v1/providers/${n}/documents/${r ?? (d ? "agreement" : "credit_terms")}`,
          c
        ).toString();
      }
      case "hfd_standard":
        return Pe(
          `${o}/api/v1/providers/${encodeURIComponent(n)}/application/terms/esignDoc`,
          c
        ).toString();
      default:
        return Pe(
          `${o}/api/v1/providers/${n}/application/terms/${s}`,
          c
        ).toString();
    }
  }
  async getDisclosures(t, r) {
    return await this.client.getDisclosures(t, r);
  }
  getDisclosuresUrl(t) {
    const r = this.client.baseUrl ?? "", n = this.client.sessionId ?? "", i = t ?? this.provider, o = t ? x(t) : this.providerKey, a = {
      sid: n
    };
    return o === "fortiva_standard" ? (a.convertToImage = "false", Pe(
      `${r}/api/v1/providers/${i}/documents/electronic_consent`,
      a
    ).toString()) : null;
  }
  getTermsHtml() {
    return this.client.getTermsHtml(this.provider);
  }
  getAgreementHtml() {
    return this.client.getAgreementHtml(this.provider);
  }
}
class Do extends H {
  client;
  constructor(t, r) {
    super(r), this.client = t;
  }
  async switchTestCase(t) {
    const r = await this.client.loadTestCase(t);
    if (r) {
      const n = w();
      n.applyMode = r.applyMode, n.applyStage = r.applyMode, n.application = { ...r.application }, n.originalApplication = {
        ...r.application
      }, r.fields.length && j().setFields(r.fields), r.providers.length && v().initializeCascade(r.providers);
    }
  }
}
const Ne = {
  AccountServiceKey: /* @__PURE__ */ Symbol("accountService"),
  VerificationServiceKey: /* @__PURE__ */ Symbol(
    "verificationService"
  ),
  GoogleTagManagerKey: /* @__PURE__ */ Symbol(
    "google-tag-manager"
  ),
  OmniApplyClientKey: zr
}, Fo = {
  install: (e, t) => {
    const r = _(), n = O();
    e.use(Yr, {
      baseUrl: t.api.omniApply.baseUrl,
      onSessionTimeout: () => n.doTimeout(),
      requestIdProvider: () => gr(),
      sessionProvider: () => n.sessionId
    });
    const i = Jr(e);
    e.provide(
      Ne.AccountServiceKey,
      new Wi(i, r)
    ), e.provide(
      Ne.VerificationServiceKey,
      new Pr(i, r)
    ), e.provide(Ne.GoogleTagManagerKey, new U());
  }
}, No = (e) => {
  if (typeof e == "string")
    return {
      name: e.startsWith("/") ? void 0 : e,
      path: e.startsWith("/") ? e : void 0
    };
  const { to: t, params: r, ...n } = e;
  return t.startsWith("/") ? {
    path: t,
    ...n
  } : {
    name: t,
    params: r,
    ...n
  };
};
class xo {
  router;
  loader;
  constructor(t, r) {
    this.router = t, this.loader = r;
  }
  listen() {
    const t = W();
    G(
      () => t.group,
      (r) => this.loadGroupRoutes(r)
    ), t.group && this.loadGroupRoutes(t.group);
  }
  loadGroupRoutes(t) {
    cn(`routes-${t}`, async () => {
      const r = await this.loader(t);
      r?.length && this.importRoutes(t, r);
    });
  }
  importRoutes(t, r) {
    r.forEach((n) => this.importRoute(t, n));
  }
  importRoute(t, r, n = !0) {
    const i = r.name;
    r.meta = {
      ...r.meta || {},
      group: t
    }, i && (r.name = `${i.toString()}.${t}`);
    const o = r.meta.appendTo;
    o ? this.router.addRoute(o, r) : n && this.router.addRoute(r), r.children?.forEach((a) => this.importRoute(t, a, !1));
  }
}
const Er = () => (e) => {
  const t = Lr();
  if (e.name === t.error)
    return !0;
  const r = O();
  if (r.needsRestore && e.meta.restore === !0 || r.isActive || e.meta.public === !0)
    return !0;
  const n = We();
  let i = t.unauthorized;
  return n.error && (i = t.error), r.timedout && (i = t.session_timeout), r.needsRestore && (i = t.session_restore), i.startsWith("/") ? {
    path: i,
    replace: !0
  } : {
    name: i,
    replace: !0
  };
}, Lo = () => (e, t) => {
  t.meta.cleanup && t.name && je().removeRoute(t.name);
}, Cr = () => async (e) => {
  const t = Lr();
  if (e.name === t.error)
    return !0;
  const r = new URLSearchParams(window.location.search), n = r.get("go"), i = r.get("returnId");
  if (!n)
    return !0;
  const o = _();
  i && await o.reloadStoreFromSession(i), o.clearedStoredAppStates(), r.delete("go"), r.delete("returnId");
  const a = new URL(window.location.href), s = {};
  for (const [c, l] of r.entries())
    s[c] = l, r.delete(c);
  return await L(), a.search = "", window.history.replaceState(null, "unused", a.toString()), {
    path: n,
    query: s,
    replace: !0
  };
}, Ir = () => (e, t) => {
  const r = re();
  setTimeout(() => {
    r({
      type: "page-view",
      toUrl: e.fullPath,
      fromUrl: t.fullPath
    });
  }, 0), U.getInstance().push({
    event: "vue.RouteChange",
    current_page_name: e.name?.toString()?.replace(/-/g, " ")?.replace(/\./g, " ")?.replace(/\b\w/g, (n) => n.toUpperCase()),
    current_page_url: e.fullPath,
    previous_page_url: t.fullPath
  });
}, Ko = (e, t) => e.path === t, Uo = (e, t) => e.meta?.extends === t, Mr = (e, t) => {
  const r = e.meta || {}, n = !r.groupId || r.groupId === t.group, i = !r.applyMode || r.applyMode === t.mode, o = !r.providerKey || r.providerKey === t.providerKey;
  return n && i && o;
}, Or = (e, t) => Ue(t.meta || {}).length - Ue(e.meta || {}).length, Ct = (e) => {
  const t = e.matched.length;
  return t ? e.matched[t - 1]?.path ?? e.path : e.path;
}, Tr = (e, t) => e.redirectedFrom ? e.redirectedFrom.name === t.name || Tr(e.redirectedFrom, t) : e.meta.extends === t.name, Bo = (e) => {
  const t = (n, i, o) => {
    if (n.meta.extends) {
      const s = e.router.getRoutes().find((c) => c.name === n.meta.extends);
      if (s) {
        const c = Ct(i);
        return s.path === c && o.path !== c;
      }
    }
    const a = Ct(i);
    return n.path === a && o.path !== a;
  }, r = (n) => n.params.finalized === "true";
  return (n, i) => {
    const o = e.router.computeGlobalRouteParams();
    if (r(n))
      return;
    const a = e.router.getRoutes().filter((s) => t(s, n, i)).filter((s) => Mr(s, o)).sort(Or);
    if (a.length) {
      const s = a[0];
      return s == null || Tr(n, s) || n.name === s.name ? void 0 : {
        name: s.name,
        params: {
          ...o,
          resolvedBy: s?.name?.toString(),
          finalized: "true"
        }
      };
    }
  };
};
class ko {
  router;
  listeners = [];
  store;
  routeByName = {};
  constructor(t, r) {
    this.router = this.buildRouter(t), this.store = r, this.router.addRoute({
      name: "__internal.error",
      path: "/internal/error",
      redirect: t.generalRouteMappings.error
    });
    const n = {
      routerSettings: t,
      router: this
    };
    this.beforeEach(er()), this.beforeEach(Cr()), this.beforeEach(Er()), t.useLocalizedRouteGuard && this.beforeEach(Bo(n)), t.beforeResolve?.length && t.beforeResolve.forEach((i) => {
      this.beforeResolve(i(r));
    }), this.afterEach(Ir()), this.afterEach(tr()), this.listeners.push(
      new xo(this, t.groupRouteLoader)
    );
  }
  buildRouter(t) {
    const { routes: r, ...n } = t;
    this.populateRoutes(r);
    const i = this.mergeRoutes(r);
    return ir({
      routes: i,
      ...n
    });
  }
  install(t) {
    this.router.install(t), t.config.globalProperties.$router = this, t.provide(Pn, this), this.listeners.forEach((r) => r.listen());
  }
  get listening() {
    return this.router.listening;
  }
  get currentRoute() {
    return this.router.currentRoute;
  }
  get options() {
    return this.router.options;
  }
  addRoute(t, r) {
    if (typeof t == "string" && r)
      return this.populateRoute(r), this.router.addRoute(t, this.mergeRoute(r));
    const n = t;
    return this.populateRoute(n), this.router.addRoute(this.mergeRoute(n));
  }
  afterEach(t) {
    return this.router.afterEach(t);
  }
  back() {
    return this.router.back();
  }
  beforeEach(t) {
    return this.router.beforeEach(t);
  }
  beforeResolve(t) {
    return this.router.beforeResolve(t);
  }
  forward() {
    return this.router.forward();
  }
  findRouteByName(t) {
    return this.routeByName[t];
  }
  getRoutes() {
    return this.router.getRoutes();
  }
  go(t) {
    this.router.go(t);
  }
  hasRoute(t) {
    return this.router.hasRoute(t);
  }
  isReady() {
    return this.router.isReady();
  }
  push(t) {
    return this.router.push(this.computeRouteLocation(t));
  }
  removeRoute(t) {
    delete this.routeByName[t], this.router.removeRoute(t);
  }
  replace(t) {
    return this.router.replace(this.computeRouteLocation(t));
  }
  resolve(t, r) {
    return this.router.resolve(t, r);
  }
  onError(t) {
    return this.router.onError(t);
  }
  clearRoutes() {
    this.router.clearRoutes();
  }
  computeRouteLocation(t) {
    return typeof t == "string" ? this.computeRouteLocation({
      name: t.startsWith("/") ? void 0 : t,
      path: t.startsWith("/") ? t : void 0
    }) : "name" in t && t.name ? this.resolveByRouteName(t) : "path" in t && t.path ? this.resolveByRoutePath(t) : t;
  }
  resolveByRoutePath(t) {
    const n = wn(
      this.router.getRoutes(),
      this.router.options
    ).resolve(
      { path: t.path },
      Zr(this.router.currentRoute)
    );
    if (n?.name)
      return this.resolveByRouteName({
        name: n.name,
        params: n.params,
        query: t.query
      });
    if (n?.matched.length) {
      const i = n.matched[n.matched.length - 1];
      if (i?.name)
        return this.resolveByRouteName({
          name: i.name,
          params: n.params,
          query: t.query
        });
    }
    return t;
  }
  resolveByRouteName(t) {
    const r = this.router.getRoutes().find((o) => o.name === t.name);
    if (!r)
      return t;
    const n = {
      ...this.computeGlobalRouteParams(),
      ...t.params
    }, i = this.router.getRoutes().filter(
      (o) => Ko(o, r.path) || Uo(o, r.name)
    ).filter((o) => Mr(o, n)).sort(Or);
    return i.length ? {
      name: i[0]?.name ?? r.name,
      hash: t.hash,
      params: n,
      query: t.query
    } : {
      name: r?.name,
      hash: t.hash,
      params: n,
      query: t.query
    };
  }
  computeGlobalRouteParams() {
    const t = this.store.group, r = this.store.applyMode, n = this.store.currentProviderKey, i = n ? x(n) : null;
    return {
      decision: (n ? this.store.applyResponse(n) || this.store.preauthResponse(n) : null)?.responseCode,
      group: t,
      mode: r,
      providerKey: i
    };
  }
  mergeRoutes(t) {
    return t.map((r) => this.mergeRoute(r));
  }
  mergeRoute(t) {
    let r = t;
    t.children && (r = {
      ...t,
      children: this.mergeRoutes(t.children)
    });
    const n = t.meta?.extends;
    if (!n)
      return r;
    const i = this.routeByName[n];
    if (!i)
      return r;
    const o = i.meta;
    if (!o)
      return r;
    const a = r.meta, s = a ? { ...o, ...a } : o;
    return !s || a === s || (r === t && (r = { ...t }), r.meta = s), r;
  }
  populateRoutes(t) {
    t.forEach((r) => {
      this.populateRoute(r);
    });
  }
  populateRoute(t) {
    if (t.name) {
      const r = t.name;
      if (this.routeByName[r])
        throw new Error(`Route name [${r}] is already defined.`);
      this.routeByName[r] = t;
    }
    t.children && this.populateRoutes(t.children);
  }
}
const qo = (e) => (t) => e.runWithContext(() => {
  const r = b("GlobalErrorHandler");
  r.error(
    "attempting to recover from preload error ->",
    t.payload.message
  );
  const n = _(), i = n.flowSessionId;
  if (!i) {
    r.error("Unable to recover from preload, no flowSessionId");
    return;
  }
  const o = or();
  n.persistStoreToSession(i).then(() => {
    const a = new URL(yi());
    a.searchParams.append("go", o.fullPath), a.searchParams.append("returnId", i), window.location.replace(a);
  });
}), Go = (e) => {
  window.addEventListener("vite:preloadError", qo(e));
}, _r = {
  install: (e, t) => {
    const r = e.config.globalProperties.$router, n = () => {
      const i = e.runWithContext(
        () => b("GlobalErrorHandler.attemptErrorNavigation")
      );
      L().then(() => r.replace(No(t))).catch((o) => {
        B(o), i.error(`Failed to navigate to error route ${t}`, o);
      });
    };
    r.onError((i, o, a) => {
      B(i), e.runWithContext(() => {
        const s = b("GlobalErrorHandler"), c = We(), l = re(), d = `Error Routing to ${o.name?.toString()} from ${a.name?.toString()}`;
        s.error(d, i), c.error = i, c.info = d, l({
          type: "error",
          category: "navigation",
          code: "app",
          message: d
        });
      }), n();
    }), e.config.errorHandler = (i, o, a) => {
      B(i), e.runWithContext(() => {
        const s = b("GlobalErrorHandler"), c = We();
        s.error(a, i), c.error = i, c.info = a;
        const l = re();
        i instanceof Qr ? l({
          type: "error",
          category: i.error.category,
          code: i.error.code,
          message: i.error.message,
          cloudRequestId: i.cloudRequestId,
          httpStatusCode: i.statusCode,
          httpMethod: i.httpMethod,
          path: i.path
        }) : l({
          type: "error",
          category: "unknown",
          code: "app",
          message: a
        });
      }), n();
    }, Go(e);
  }
}, Ze = {
  error: "/error/general",
  exit: "/exit",
  session_restore: "/session/restore",
  session_timeout: "/error/timeout",
  unauthorized: "/error/unauthorized"
}, $o = (e) => (t) => {
  if (typeof t == "boolean")
    return t;
  const r = typeof t == "string" ? e.conditions[t] : t;
  return typeof r == "function" && r({
    route: e.currentRoute.value
  });
}, Dr = /* @__PURE__ */ Symbol("general-route-mappings"), Fr = /* @__PURE__ */ Symbol("route-condition-evaluator"), Nr = (e, t, r) => {
  const n = $o({
    currentRoute: t.currentRoute,
    conditions: r
  });
  e.provide(Fr, n);
}, xr = () => ({
  top: 0
}), Vo = (e, t) => {
  const r = ir({
    ...t,
    history: sr(t.baseUrl),
    scrollBehavior: t.scrollBehavior ?? xr
  }), n = {
    ...Ze,
    ...t.generalRouteMappings ?? {}
  };
  r.addRoute({
    name: "__internal.error",
    path: "/internal/error",
    redirect: n.error
  }), r.beforeEach(er()), r.beforeEach(Cr()), r.beforeEach(Er()), r.afterEach(Ir()), r.afterEach(tr()), r.afterEach(Lo()), t.customizeRouter && t.customizeRouter(r), e.use(r).use(_r, n.error), Nr(e, r, {});
}, Wo = (e, t) => {
  const r = {
    ...t,
    routeConditions: t.routeConditions ?? {},
    generalRouteMappings: t.generalRouteMappings ?? Ze,
    history: sr(t.baseUrl),
    scrollBehavior: t.scrollBehavior ?? xr
  };
  e.provide(Dr, r.generalRouteMappings);
  const n = new ko(r, _());
  e.use(n).use(_r, r.generalRouteMappings.error), Nr(e, n, r.routeConditions ?? {});
}, jo = {
  install: (e, t) => {
    t.mode === "complicated" ? Wo(e, t) : Vo(e, t);
  }
}, Lr = () => ({
  ...Ze,
  ...be(Dr, void 0) ?? {}
}), Ho = () => {
  const e = be(Fr);
  if (!e)
    throw new Error("RouteConditionEvaluator has not been provided!");
  return e;
}, sc = (e) => {
  const t = Ho(), r = or();
  return m(() => t(typeof e == "function" ? e(r.meta) : r.meta[e]));
}, ac = () => {
  const e = je();
  return () => e.replace({
    name: "__internal.error"
  });
}, zo = (e, t) => (t.forEach((r) => {
  const n = r.meta || {};
  n.providerKey = e, r.meta = n, r.children && zo(e, r.children);
}), t), cc = (e, t) => {
  let r;
  const n = e.matched.length;
  return n > 1 ? r = e.matched[n - 2].path : r = e.matched[0].path, `${r}/${t}`;
}, Kr = /* @__PURE__ */ Symbol("app-options"), Yo = {
  install(e, t) {
    const r = gn();
    if (e.config.globalProperties.$appOptions = t, e.config.globalProperties.$eventBus = r, e.use(hn()), t.mode === "development" && Fi(), e.provide(Kr, t).use(t.i18n).use(Fo, t).use(jo, t.router), t.plugins?.forEach((n) => e.use(n)), t.configurePlugins) {
      const n = e.use.bind(e);
      t.configurePlugins(n);
    }
  }
}, Jo = (e) => Xr(e.root).use(Yo, e), Ur = () => {
  const e = be(Kr) ?? be("app-options");
  if (!e)
    throw new Error("Unable to find active SDK instance, did you install it?");
  return e;
}, lc = (e) => {
  const t = Jo(e);
  return t.mount(e.rootContainer ?? "#app"), Qo(), t;
};
function Qo() {
  const e = document.body;
  e.classList.add("vc-body"), hr() && e.classList.add("vc-window--has-opener"), yr() && e.classList.add("vc-window--has-parent"), Ye() && e.classList.add("vc-window--opened-externally");
}
const Zo = () => {
  let e = !1;
  try {
    e = Ur().mode === "production";
  } catch (t) {
    console.debug(t);
  }
  return m(() => e);
}, b = (e) => {
  const t = Zo(), r = g(), n = _();
  return new Gi(e, t, [
    new $i(),
    new Vi(r, n)
  ]);
}, Te = (e, t, r = { immediate: !0 }) => {
  const n = b("use-polling.ts"), i = async () => {
    let s = !1;
    try {
      await e() && (s = !0);
    } catch (c) {
      n.error("Uncaught error in polling...we'll keep trying", c);
    }
    s || o();
  }, { start: o, stop: a } = pn(
    i,
    t,
    {
      immediate: !1
    }
  );
  return Jt(async () => {
    r.manual || (r.immediate ? await i() : o());
  }), Qt(() => a()), {
    start: o,
    stop: a
  };
};
window.dataLayer ??= [];
class U {
  static GLOBAL;
  _dataLayer = window.dataLayer;
  constructor() {
    this.setInitialEnvironment(), this.listen(), U.GLOBAL || (U.GLOBAL = this);
  }
  set flowSessionId(t) {
    this._dataLayer.push({ apply_session_id: t });
  }
  set environment(t) {
    this._dataLayer.push({ environment: t });
  }
  set groupId(t) {
    this._dataLayer.push({ group_id: t });
  }
  set provider(t) {
    this._dataLayer.push({ current_provider_key: t });
  }
  set applyMode(t) {
    this._dataLayer.push({ current_apply_mode: t });
  }
  push(t) {
    this._dataLayer.push(t);
  }
  setInitialEnvironment() {
    const t = window.location.host;
    t.startsWith("apply-next-demo") ? this.environment = "demo" : t.startsWith("apply-next-test") ? this.environment = "test" : t.startsWith("apply-next-uat") ? this.environment = "uat" : t === "apply-next.versatilecredit.com" || // Whitelabel domains (maybe...) lol
    t.indexOf("versatilecredit") === -1 && t.indexOf(".com") > -1 ? this.environment = "prod" : this.environment = "dev";
    const r = W();
    this.groupId = r.group;
    const n = w();
    this.applyMode = n.applyMode;
    const i = v();
    this.provider = i.currentProviderKey;
    const o = O();
    this.flowSessionId = o.flowSessionId;
  }
  listen() {
    const t = W();
    G(
      () => t.group,
      (o) => this.groupId = o
    );
    const r = w();
    G(
      () => r.applyMode,
      (o) => this.applyMode = o
    );
    const n = v();
    G(
      () => n.currentProviderKey,
      (o) => this.provider = o
    );
    const i = O();
    G(
      () => i.environment,
      (o) => this.environment = o
    ), G(
      () => i.flowSessionId,
      (o) => this.flowSessionId = o
    );
  }
  static getInstance() {
    return U.GLOBAL || (U.GLOBAL = new U()), U.GLOBAL;
  }
}
const dc = (e) => {
  const t = g();
  return {
    exists: (r) => t.checkUserExists(f(e), r)
  };
}, uc = (e) => {
  const t = g();
  return {
    login: (r) => t.providerUserLogin(f(e), r)
  };
}, pc = (e) => {
  const t = g();
  return {
    send: (r) => t.sendProviderUserPasscode(f(e), r)
  };
};
function Xo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var xe, It;
function es() {
  if (It) return xe;
  It = 1;
  var e = function(y) {
    return t(y) && !r(y);
  };
  function t(h) {
    return !!h && typeof h == "object";
  }
  function r(h) {
    var y = Object.prototype.toString.call(h);
    return y === "[object RegExp]" || y === "[object Date]" || o(h);
  }
  var n = typeof Symbol == "function" && Symbol.for, i = n ? /* @__PURE__ */ Symbol.for("react.element") : 60103;
  function o(h) {
    return h.$$typeof === i;
  }
  function a(h) {
    return Array.isArray(h) ? [] : {};
  }
  function s(h, y) {
    return y.clone !== !1 && y.isMergeableObject(h) ? E(a(h), h, y) : h;
  }
  function c(h, y, R) {
    return h.concat(y).map(function(I) {
      return s(I, R);
    });
  }
  function l(h, y) {
    if (!y.customMerge)
      return E;
    var R = y.customMerge(h);
    return typeof R == "function" ? R : E;
  }
  function d(h) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(h).filter(function(y) {
      return Object.propertyIsEnumerable.call(h, y);
    }) : [];
  }
  function u(h) {
    return Object.keys(h).concat(d(h));
  }
  function C(h, y) {
    try {
      return y in h;
    } catch {
      return !1;
    }
  }
  function P(h, y) {
    return C(h, y) && !(Object.hasOwnProperty.call(h, y) && Object.propertyIsEnumerable.call(h, y));
  }
  function A(h, y, R) {
    var I = {};
    return R.isMergeableObject(h) && u(h).forEach(function(M) {
      I[M] = s(h[M], R);
    }), u(y).forEach(function(M) {
      P(h, M) || (C(h, M) && R.isMergeableObject(y[M]) ? I[M] = l(M, R)(h[M], y[M], R) : I[M] = s(y[M], R));
    }), I;
  }
  function E(h, y, R) {
    R = R || {}, R.arrayMerge = R.arrayMerge || c, R.isMergeableObject = R.isMergeableObject || e, R.cloneUnlessOtherwiseSpecified = s;
    var I = Array.isArray(y), M = Array.isArray(h), qr = I === M;
    return qr ? I ? R.arrayMerge(h, y, R) : A(h, y, R) : s(y, R);
  }
  E.all = function(y, R) {
    if (!Array.isArray(y))
      throw new Error("first argument should be an array");
    return y.reduce(function(I, M) {
      return E(I, M, R);
    }, {});
  };
  var q = E;
  return xe = q, xe;
}
var ts = es();
const rs = /* @__PURE__ */ Xo(ts), fc = () => {
  const e = g(), t = w(), r = v();
  return async (n, i) => {
    const o = await e.accountLookup(n, i), { responseCode: a } = o.applicationResponse;
    switch (a) {
      case "prequalified":
        t.switchApplyMode("prequalify"), r.setPreauthResponse(o.applicationResponse), o.applicationData && (t.application = t.application ? rs(t.application, o.applicationData) : structuredClone(o.applicationData));
        break;
      case "approved":
        t.switchApplyMode("full"), r.setApplyResponse(o.applicationResponse);
        break;
    }
    return o;
  };
}, mc = [
  { id: "AL", name: "AL" },
  { id: "AK", name: "AK" },
  { id: "AZ", name: "AZ" },
  { id: "AR", name: "AR" },
  { id: "AA", name: "AA" },
  { id: "AE", name: "AE" },
  { id: "AP", name: "AP" },
  { id: "AS", name: "AS" },
  { id: "CA", name: "CA" },
  { id: "CO", name: "CO" },
  { id: "CT", name: "CT" },
  { id: "DC", name: "DC" },
  { id: "DE", name: "DE" },
  { id: "FL", name: "FL" },
  { id: "FM", name: "FM" },
  { id: "GA", name: "GA" },
  { id: "GU", name: "GU" },
  { id: "HI", name: "HI" },
  { id: "ID", name: "ID" },
  { id: "IL", name: "IL" },
  { id: "IN", name: "IN" },
  { id: "IA", name: "IA" },
  { id: "KS", name: "KS" },
  { id: "KY", name: "KY" },
  { id: "LA", name: "LA" },
  { id: "ME", name: "ME" },
  { id: "MD", name: "MD" },
  { id: "MA", name: "MA" },
  { id: "MI", name: "MI" },
  { id: "MN", name: "MN" },
  { id: "MS", name: "MS" },
  { id: "MO", name: "MO" },
  { id: "MT", name: "MT" },
  { id: "MH", name: "MH" },
  { id: "MP", name: "MP" },
  { id: "NE", name: "NE" },
  { id: "NV", name: "NV" },
  { id: "NH", name: "NH" },
  { id: "NJ", name: "NJ" },
  { id: "NM", name: "NM" },
  { id: "NY", name: "NY" },
  { id: "NC", name: "NC" },
  { id: "ND", name: "ND" },
  { id: "OH", name: "OH" },
  { id: "OK", name: "OK" },
  { id: "OR", name: "OR" },
  { id: "PA", name: "PA" },
  { id: "PR", name: "PR" },
  { id: "PW", name: "PW" },
  { id: "RI", name: "RI" },
  { id: "SC", name: "SC" },
  { id: "SD", name: "SD" },
  { id: "TN", name: "TN" },
  { id: "TX", name: "TX" },
  { id: "UT", name: "UT" },
  { id: "VT", name: "VT" },
  { id: "VA", name: "VA" },
  { id: "VI", name: "VI" },
  { id: "WA", name: "WA" },
  { id: "WV", name: "WV" },
  { id: "WI", name: "WI" },
  { id: "WY", name: "WY" }
], hc = [
  { id: "USA", name: "United States of America" },
  { id: "AFG", name: "Afghanistan" },
  { id: "ALB", name: "Albania" },
  { id: "DZA", name: "Algeria" },
  { id: "ASM", name: "American Samoa" },
  { id: "AND", name: "Andorra" },
  { id: "AGO", name: "Angola" },
  { id: "AIA", name: "Anguilla" },
  { id: "ATA", name: "Antarctica" },
  { id: "ATG", name: "Antigua and Barbuda" },
  { id: "ARG", name: "Argentina" },
  { id: "ARM", name: "Armenia" },
  { id: "ABW", name: "Aruba " },
  { id: "AUS", name: "Australia" },
  { id: "AUT", name: "Austria" },
  { id: "AZE", name: "Azerbaijan" },
  { id: "BHS", name: "Bahamas" },
  { id: "BHR", name: "Bahrain" },
  { id: "BGD", name: "Bangladesh" },
  { id: "BRB", name: "Barbados" },
  { id: "BLR", name: "Belarus" },
  { id: "BEL", name: "Belgium" },
  { id: "BLZ", name: "Belize" },
  { id: "BEN", name: "Benin" },
  { id: "BMU", name: "Bermuda" },
  { id: "BTN", name: "Bhutan" },
  { id: "BOL", name: "Bolivia (Plurinational State of)" },
  { id: "BES", name: "Bonaire, Sint Eustatius and Saba" },
  { id: "BIH", name: "Bosnia and Herzegovina" },
  { id: "BWA", name: "Botswana" },
  { id: "BVT", name: "Bouvet Island" },
  { id: "BRA", name: "Brazil" },
  { id: "IOT", name: "British Indian Ocean Territory" },
  { id: "BRN", name: "Brunei Darussalam" },
  { id: "BGR", name: "Bulgaria" },
  { id: "BFA", name: "Burkina Faso" },
  { id: "BDI", name: "Burundi" },
  { id: "CPV", name: "Cabo Verde" },
  { id: "KHM", name: "Cambodia" },
  { id: "CMR", name: "Cameroon" },
  { id: "CAN", name: "Canada" },
  { id: "CYM", name: "Cayman Islands" },
  { id: "CAF", name: "Central African Republic" },
  { id: "TCD", name: "Chad" },
  { id: "CHL", name: "Chile" },
  { id: "CHN", name: "China" },
  { id: "CXR", name: "Christmas Island" },
  { id: "CCK", name: "Cocos (Keeling) Islands" },
  { id: "COL", name: "Colombia" },
  { id: "COM", name: "Comoros" },
  { id: "COD", name: "Congo (the Democratic Republic of the)" },
  { id: "COG", name: "Congo" },
  { id: "COK", name: "Cook Islands" },
  { id: "CRI", name: "Costa Rica" },
  { id: "HRV", name: "Croatia" },
  { id: "CUB", name: "Cuba" },
  { id: "CUW", name: "Curaçao" },
  { id: "CYP", name: "Cyprus" },
  { id: "CZE", name: "Czechia" },
  { id: "CIV", name: "Côte d'Ivoire" },
  { id: "DNK", name: "Denmark" },
  { id: "DJI", name: "Djibouti" },
  { id: "DMA", name: "Dominica" },
  { id: "DOM", name: "Dominican Republic" },
  { id: "ECU", name: "Ecuador" },
  { id: "EGY", name: "Egypt" },
  { id: "SLV", name: "El Salvador" },
  { id: "GNQ", name: "Equatorial Guinea" },
  { id: "ERI", name: "Eritrea" },
  { id: "EST", name: "Estonia" },
  { id: "SWZ", name: "Eswatini" },
  { id: "ETH", name: "Ethiopia" },
  { id: "FLK", name: "Falkland Islands" },
  { id: "FRO", name: "Faroe Islands" },
  { id: "FJI", name: "Fiji" },
  { id: "FIN", name: "Finland" },
  { id: "FRA", name: "France" },
  { id: "GUF", name: "French Guiana" },
  { id: "PYF", name: "French Polynesia" },
  { id: "ATF", name: "French Southern Territories" },
  { id: "GAB", name: "Gabon" },
  { id: "GMB", name: "Gambia" },
  { id: "GEO", name: "Georgia" },
  { id: "DEU", name: "Germany" },
  { id: "GHA", name: "Ghana" },
  { id: "GIB", name: "Gibraltar" },
  { id: "GRC", name: "Greece" },
  { id: "GRL", name: "Greenland" },
  { id: "GRD", name: "Grenada" },
  { id: "GLP", name: "Guadeloupe" },
  { id: "GUM", name: "Guam" },
  { id: "GTM", name: "Guatemala" },
  { id: "GGY", name: "Guernsey" },
  { id: "GIN", name: "Guinea" },
  { id: "GNB", name: "Guinea-Bissau" },
  { id: "GUY", name: "Guyana" },
  { id: "HTI", name: "Haiti" },
  { id: "HMD", name: "Heard Island and McDonald Islands" },
  { id: "VAT", name: "Holy See" },
  { id: "HND", name: "Honduras" },
  { id: "HKG", name: "Hong Kong" },
  { id: "HUN", name: "Hungary" },
  { id: "ISL", name: "Iceland" },
  { id: "IND", name: "India" },
  { id: "IDN", name: "Indonesia" },
  { id: "IRN", name: "Iran" },
  { id: "IRQ", name: "Iraq" },
  { id: "IRL", name: "Ireland" },
  { id: "IMN", name: "Isle of Man" },
  { id: "ISR", name: "Israel" },
  { id: "ITA", name: "Italy" },
  { id: "JAM", name: "Jamaica" },
  { id: "JPN", name: "Japan" },
  { id: "JEY", name: "Jersey" },
  { id: "JOR", name: "Jordan" },
  { id: "KAZ", name: "Kazakhstan" },
  { id: "KEN", name: "Kenya" },
  { id: "KIR", name: "Kiribati" },
  { id: "PRK", name: "Korea (the Democratic People's Republic of)" },
  { id: "KOR", name: "Korea (the Republic of)" },
  { id: "KWT", name: "Kuwait" },
  { id: "KGZ", name: "Kyrgyzstan" },
  { id: "LAO", name: "Lao People's Democratic Republic" },
  { id: "LVA", name: "Latvia" },
  { id: "LBN", name: "Lebanon" },
  { id: "LSO", name: "Lesotho" },
  { id: "LBR", name: "Liberia" },
  { id: "LBY", name: "Libya" },
  { id: "LIE", name: "Liechtenstein" },
  { id: "LTU", name: "Lithuania" },
  { id: "LUX", name: "Luxembourg" },
  { id: "MAC", name: "Macao" },
  { id: "MDG", name: "Madagascar" },
  { id: "MWI", name: "Malawi" },
  { id: "MYS", name: "Malaysia" },
  { id: "MDV", name: "Maldives" },
  { id: "MLI", name: "Mali" },
  { id: "MLT", name: "Malta" },
  { id: "MHL", name: "Marshall Islands" },
  { id: "MTQ", name: "Martinique" },
  { id: "MRT", name: "Mauritania" },
  { id: "MUS", name: "Mauritius" },
  { id: "MYT", name: "Mayotte" },
  { id: "MEX", name: "Mexico" },
  { id: "FSM", name: "Micronesia" },
  { id: "MDA", name: "Moldova" },
  { id: "MCO", name: "Monaco" },
  { id: "MNG", name: "Mongolia" },
  { id: "MNE", name: "Montenegro" },
  { id: "MSR", name: "Montserrat" },
  { id: "MAR", name: "Morocco" },
  { id: "MOZ", name: "Mozambique" },
  { id: "MMR", name: "Myanmar" },
  { id: "NAM", name: "Namibia" },
  { id: "NRU", name: "Nauru" },
  { id: "NPL", name: "Nepal" },
  { id: "NLD", name: "Netherlands" },
  { id: "NCL", name: "New Caledonia" },
  { id: "NZL", name: "New Zealand" },
  { id: "NIC", name: "Nicaragua" },
  { id: "NER", name: "Niger" },
  { id: "NGA", name: "Nigeria" },
  { id: "NIU", name: "Niue" },
  { id: "NFK", name: "Norfolk Island" },
  { id: "MNP", name: "Northern Mariana Islands" },
  { id: "NOR", name: "Norway" },
  { id: "OMN", name: "Oman" },
  { id: "PAK", name: "Pakistan" },
  { id: "PLW", name: "Palau" },
  { id: "PSE", name: "Palestine, State of" },
  { id: "PAN", name: "Panama" },
  { id: "PNG", name: "Papua New Guinea" },
  { id: "PRY", name: "Paraguay" },
  { id: "PER", name: "Peru" },
  { id: "PHL", name: "Philippines" },
  { id: "PCN", name: "Pitcairn" },
  { id: "POL", name: "Poland" },
  { id: "PRT", name: "Portugal" },
  { id: "PRI", name: "Puerto Rico" },
  { id: "QAT", name: "Qatar" },
  { id: "MKD", name: "Republic of North Macedonia" },
  { id: "ROU", name: "Romania" },
  { id: "RUS", name: "Russian Federation" },
  { id: "RWA", name: "Rwanda" },
  { id: "REU", name: "Réunion" },
  { id: "BLM", name: "Saint Barthélemy" },
  { id: "SHN", name: "Saint Helena, Ascension and Tristan da Cunha" },
  { id: "KNA", name: "Saint Kitts and Nevis" },
  { id: "LCA", name: "Saint Lucia" },
  { id: "MAF", name: "Saint Martin (French part)" },
  { id: "SPM", name: "Saint Pierre and Miquelon" },
  { id: "VCT", name: "Saint Vincent and the Grenadines" },
  { id: "WSM", name: "Samoa" },
  { id: "SMR", name: "San Marino" },
  { id: "STP", name: "Sao Tome and Principe" },
  { id: "SAU", name: "Saudi Arabia" },
  { id: "SEN", name: "Senegal" },
  { id: "SRB", name: "Serbia" },
  { id: "SYC", name: "Seychelles" },
  { id: "SLE", name: "Sierra Leone" },
  { id: "SGP", name: "Singapore" },
  { id: "SXM", name: "Sint Maarten (Dutch part)" },
  { id: "SVK", name: "Slovakia" },
  { id: "SVN", name: "Slovenia" },
  { id: "SLB", name: "Solomon Islands" },
  { id: "SOM", name: "Somalia" },
  { id: "ZAF", name: "South Africa" },
  { id: "SGS", name: "South Georgia and the South Sandwich Islands" },
  { id: "SSD", name: "South Sudan" },
  { id: "ESP", name: "Spain" },
  { id: "LKA", name: "Sri Lanka" },
  { id: "SDN", name: "Sudan" },
  { id: "SUR", name: "Suriname" },
  { id: "SJM", name: "Svalbard and Jan Mayen" },
  { id: "SWE", name: "Sweden" },
  { id: "CHE", name: "Switzerland" },
  { id: "SYR", name: "Syrian Arab Republic" },
  { id: "TWN", name: "Taiwan (Province of China)" },
  { id: "TJK", name: "Tajikistan" },
  { id: "TZA", name: "Tanzania, United Republic of" },
  { id: "THA", name: "Thailand" },
  { id: "TLS", name: "Timor-Leste" },
  { id: "TGO", name: "Togo" },
  { id: "TKL", name: "Tokelau" },
  { id: "TON", name: "Tonga" },
  { id: "TTO", name: "Trinidad and Tobago" },
  { id: "TUN", name: "Tunisia" },
  { id: "TUR", name: "Turkey" },
  { id: "TKM", name: "Turkmenistan" },
  { id: "TCA", name: "Turks and Caicos Islands" },
  { id: "TUV", name: "Tuvalu" },
  { id: "UGA", name: "Uganda" },
  { id: "UKR", name: "Ukraine" },
  { id: "ARE", name: "United Arab Emirates" },
  { id: "GBR", name: "United Kingdom of Great Britain and Northern Ireland" },
  { id: "UMI", name: "United States Minor Outlying Islands" },
  { id: "URY", name: "Uruguay" },
  { id: "UZB", name: "Uzbekistan" },
  { id: "VUT", name: "Vanuatu" },
  { id: "VEN", name: "Venezuela" },
  { id: "VNM", name: "Viet Nam" },
  { id: "VGB", name: "Virgin Islands (British)" },
  { id: "VIR", name: "Virgin Islands (U.S.)" },
  { id: "WLF", name: "Wallis and Futuna" },
  { id: "ESH", name: "Western Sahara" },
  { id: "YEM", name: "Yemen" },
  { id: "ZMB", name: "Zambia" },
  { id: "ZWE", name: "Zimbabwe" },
  { id: "ALA", name: "Åland Islands" }
], yc = (e, t) => {
  const r = g();
  return fe(
    (n) => r.deliverApplicationDocuments(f(e), n),
    t
  );
}, vc = (e, t, r) => {
  const n = g();
  return Te(async () => {
    const o = await n.verifyApplicationDocumentsDelivery(
      f(e),
      f(t)
    );
    return await r(o.verified), o.verified;
  }, 1e4, {
    immediate: !1,
    manual: !0
  });
}, ns = /^(\d{3})(\d{3})(\d{4})$/, is = /^(\d)(\d{3})(\d{3})(\d{4})$/, gc = (e, t) => {
  if (t == "last4")
    return as(e);
  const r = ("" + e).replace(/\D/g, ""), n = ns.exec(r), i = is.exec(r);
  return i ? os(i, t) : n ? ss(n, t) : null;
};
function os(e, t) {
  return t == null || t == "parenthetical" ? `${e[1]} (${e[2]}) ${e[3]}-${e[4]}` : `${e[1]}-${e[2]}-${e[3]}-${e[4]}`;
}
function ss(e, t) {
  return t == null || t === "parenthetical" ? `(${e[1]}) ${e[2]}-${e[3]}` : `${e[1]}-${e[2]}-${e[3]}`;
}
function as(e) {
  return e.length > 4 ? e.substring(e.length - 4) : e;
}
function Pc(e) {
  if (isNaN(e) || !Number.isInteger(e))
    return "Invalid input: Not an integer";
  const t = e % 10, r = e % 100;
  if (r >= 11 && r <= 13)
    return e + "th";
  switch (t) {
    case 1:
      return e + "st";
    case 2:
      return e + "nd";
    case 3:
      return e + "rd";
    default:
      return e + "th";
  }
}
const wc = (e, t = 4, r = "-") => {
  if (!e)
    return e;
  const n = new RegExp(`.{1,${t}}`, "g");
  return e.match(n)?.join(r);
}, Sc = (e) => {
  const t = ("" + e).replace(/\D/g, ""), n = /^(\d{3})(\d{2})(\d{4})$/.exec(t);
  return n ? `${n[1]}-${n[2]}-${n[3]}` : null;
}, Ac = (e) => {
  const t = ("" + e).replace(/\D/g, ""), n = /^(\d{3})(\d{2})(\d{4})$/.exec(t);
  return n ? `${n[3]}` : null;
}, Rc = (e) => {
  const t = g(), r = v();
  return async (n) => {
    const i = f(e), o = await t.answerQuiz(i, n);
    if (o.status === "pending" && o.providerId === "acima") {
      const s = (await t.checkApplication(i)).provider;
      if (s) {
        r.setApplyResponse(s);
        const c = s.quizResponse?.quizId ? s.quizResponse : void 0;
        return {
          ...o,
          // If the quiz id is the same as the current quiz then it has failed
          // If the quiz id is different then another quiz needs to be completed
          status: c?.quizId === n.quizId ? "fail" : "pass",
          next: c
        };
      }
    }
    return o;
  };
}, bc = (e, t) => {
  const r = v();
  return m(() => {
    const i = r.findApplyResponse(f(e))?.quizResponse;
    return i?.quizId === f(t) ? i : void 0;
  });
}, Ec = () => ln(W()), Cc = (e) => {
  const t = W(), r = dn({
    inheritLocale: !1
  }), n = He({
    useScope: "global"
  }), i = () => {
    const o = f(e), a = `${o ? x(o) : "all"}_${t.language}`, s = `${o ? x(o) : "all"}_${t.locale}`;
    r.locale.value = s, r.fallbackLocale.value = [
      a,
      ...n.fallbackLocale.value
    ];
    const c = n.messages.value;
    s in c && r.mergeLocaleMessage(s, c[s]), a in c && r.mergeLocaleMessage(a, c[a]);
  };
  return en(() => i()), G(
    () => t.locale,
    () => i()
  ), r;
}, Ic = {
  legacy: !1,
  /**
   * The locale of localization.
   *
   * If the locale contains a territory and a dialect,
   * this locale contains an implicit fallback.
   *
   * @see https://vue-i18n.intlify.dev/api/composition.html#locale-1
   */
  locale: "en",
  /**
   * The locale of fallback localization.
   *
   * @see https://vue-i18n.intlify.dev/api/composition.html#fallbacklocale-1
   */
  fallbackLocale: ["en"],
  /**
   * In the component localization, whether to fall back to root level (global scope)
   * localization when localization fails.
   *
   * @see https://vue-i18n.intlify.dev/api/composition.html#fallbackroot-1
   */
  fallbackRoot: !0,
  /**
   * Whether suppress warnings outputted when localization fails.
   *
   * @see https://vue-i18n.intlify.dev/api/composition.html#missingwarn-1
   */
  missingWarn: !1,
  /**
   * Whether suppress warnings when falling back to either fallbackLocale or root.
   *
   * @see https://vue-i18n.intlify.dev/api/composition.html#fallbackwarn-1
   */
  fallbackWarn: !1
}, Mc = (e) => {
  const t = g(), r = b("useLaunchMobileApply"), n = async () => await t.launchFromMobileDevice(
    cs(e)
  ), { error: i, isLoading: o, isReady: a, state: s, execute: c, executeImmediate: l } = ue(
    n,
    {
      success: !1
    },
    {
      immediate: !1,
      onError: (d) => r.error("Failed to launch on mobile device ", d)
    }
  );
  return {
    error: i,
    isLoading: o,
    isReady: a,
    state: s,
    refresh: c,
    submit: l
  };
}, cs = (e) => {
  const t = w(), r = f(e);
  switch (r) {
    case "sms":
      return {
        mobilePhone: t.getApplicationValue(
          "primary.mobilePhone"
        )
      };
    case "email":
      return {
        email: t.getApplicationValue("primary.email")
      };
    default:
      throw new Error(
        `${r} is not supported. Try something else!`
      );
  }
}, Oc = (e) => {
  const t = g(), r = b("useQrCodeLaunch"), n = async () => {
    const l = f(e);
    return await t.launchApplicationFromQrCode({
      config: {
        startAt: l.startAt,
        prefill: {
          primaryApplicant: ls()
        }
      }
    });
  }, { error: i, isLoading: o, isReady: a, state: s, execute: c } = ue(
    n,
    {
      url: void 0,
      expires: void 0
    },
    {
      onError: (l) => r.error("Failed to fetch QR code ", l)
    }
  );
  return {
    error: i,
    isLoading: o,
    isReady: a,
    state: s,
    refresh: c
  };
}, ls = () => {
  const e = w();
  return {
    firstName: e.getApplicationValue("primary.firstName"),
    lastName: e.getApplicationValue("primary.lastName"),
    dateOfBirth: e.getApplicationValue("primary.dateOfBirth"),
    email: e.getApplicationValue("primary.email"),
    homePhone: e.getApplicationValue("primary.homePhone"),
    mobilePhone: e.getApplicationValue("primary.mobilePhone"),
    address: {
      line1: e.getApplicationValue("primary.homeAddress.line1"),
      line2: e.getApplicationValue("primary.homeAddress.line2"),
      city: e.getApplicationValue("primary.homeAddress.city"),
      state: e.getApplicationValue("primary.homeAddress.state"),
      zipCode: e.getApplicationValue(
        "primary.homeAddress.zipCode"
      )
    }
  };
}, Tc = () => {
  const e = Je(), { t, te: r } = He({
    useScope: "parent"
  });
  return m(
    () => e.name ?? (r("merchant.name") ? t("merchant.name") : void 0)
  );
}, _c = () => {
  const e = Je(), { t } = He({
    useScope: "parent"
  });
  return m(() => e.legalName ?? t("merchant.legal_name"));
}, Dc = (e, t) => {
  const r = b("useFetchZipCodeMetadata()"), n = g(), i = N(!1), o = fe(async (s) => {
    try {
      const c = await n.getZipCodeMetadata(s);
      t(c), await L();
    } catch (c) {
      B(c), r.error("Failed to fetch zip code metadata", c);
    }
  }, i), a = fn(
    () => f(e),
    (s) => {
      if (s != null && s.length >= 5)
        return o(s);
    }
  );
  return Qt(() => {
    a();
  }), m(() => i.value);
}, Br = () => {
  const e = b("useApplicablePreauthResponses"), t = wr(), r = v();
  return m(() => {
    const n = f(t), i = r.findProviderConfig(n);
    return i == null ? (e.error(
      `Unable to determine offers, config for ${n} is missing`
    ), []) : r.preauthResponses.filter((o) => {
      const { responseCode: a, providerKey: s } = o, c = r.findProviderConfig(s);
      return c == null ? (e.warn(`Skipping response for ${s}, config is missing`), !1) : a !== p.PREQUALIFIED && a !== p.PREAPPROVED ? !1 : s === n ? !0 : r.findApplyResponse(s) ? !1 : i.cascadeGroup === c.cascadeGroup;
    });
  });
}, Le = (e, t) => [e, t].join(":"), ds = (e) => e.filter(
  (t) => t.providerProductType == null || t.providerProductType === "credit"
), us = (e) => e.filter(
  (t) => t.providerProductType === "loan" || t.providerProductType === "bnpl"
), Mt = (e) => {
  const t = e.map((r) => r.approvedAmountCents).filter((r) => r != null);
  return Math.max(...t);
}, Fc = (e) => {
  const t = v(), r = Br(), n = /* @__PURE__ */ new Map(), i = (s) => {
    const c = t.findProviderConfig(s.providerKey), l = t.findPaymentPlans(s.providerKey), d = (C) => Rn(
      C,
      l.sort?.byFields ?? [
        "monthlyAmountCents",
        "paymentAmountCents",
        "minAmountCents",
        "providerKey"
      ]
    );
    if (s.providerId === "synchrony" && c?.providerProduct === "synchrony-multi-product") {
      const C = [], P = ds(l.paymentPlans);
      if (P.length > 0) {
        const E = structuredClone(ot(s));
        E.approvedAmountCents = Mt(P), C.push({
          id: Le(s.providerKey, "credit"),
          providerKey: s.providerKey,
          response: E,
          plans: d(P),
          productType: "credit",
          partialCoverage: !1
        });
      }
      const A = us(l.paymentPlans);
      if (A.length > 0) {
        const E = structuredClone(ot(s));
        E.approvedAmountCents = Mt(A), C.push({
          id: Le(s.providerKey, "loan"),
          providerKey: s.providerKey,
          response: E,
          plans: d(A),
          productType: "loan",
          partialCoverage: !1
        });
      }
      return C;
    }
    const u = d(l.paymentPlans);
    return [
      {
        id: Le(s.providerKey, "unknown"),
        providerKey: s.providerKey,
        response: s,
        plans: u,
        productType: c?.providerProductType,
        partialCoverage: !1
      }
    ];
  }, o = (s, c) => {
    if (c.providerKey == s.providerKey)
      return c.id.length - s.id.length;
    const l = t.cascade.findIndex(
      (u) => u.providerKey === s.providerKey
    ) ?? 0, d = t.cascade.findIndex(
      (u) => u.providerKey === c.providerKey
    ) ?? 0;
    return l - d;
  }, a = (s) => {
    const c = (l) => s.some((d) => d.id == l);
    return n.forEach((l) => {
      c(l.id) || s.push({
        ...l,
        plans: []
      });
    }), s.forEach((l) => {
      n.has(l.id) || n.set(l.id, l);
    }), s;
  };
  return m(() => {
    const s = f(r).flatMap(
      (l) => i(l)
    );
    return a(s).filter(
      (l) => l != null && e.has(l.response.providerId)
    ).sort((l, d) => o(l, d));
  });
}, Nc = (e) => {
  const t = Br();
  return m(
    () => t.value.every(({ providerId: r }) => e.has(r))
  );
}, ps = [
  p.PREQUALIFIED,
  p.PREAPPROVED,
  p.APPROVED
], fs = (e) => e && ps.includes(e.responseCode), Ot = () => ({
  paymentPlans: []
}), ms = (e) => {
  const t = K(e.providerKey);
  return fs(e) || t.fetchPaymentPlansOnError;
}, hs = (e, t, r, n) => {
  if (e.providerId != "synchrony" || t == null || r.paymentPlans.length == 0)
    return n;
  const i = r.paymentPlans.filter(
    (a) => t === "credit" ? (
      // Keep Loan Plans, replacing Credit Plans
      a.providerProductType !== "credit"
    ) : (
      // Keep Credit Plans, replacing Loan Plans
      a.providerProductType === "credit"
    )
  ), o = n.paymentPlans.filter(
    (a) => t === "credit" ? (
      // Keep new Credit Plans
      a.providerProductType === "credit"
    ) : (
      // Keep NEW Loan Plans
      a.providerProductType !== "credit"
    )
  );
  return {
    ...n,
    paymentPlans: [...i, ...o]
  };
}, ys = (e = {}) => {
  const t = b("useFetchPaymentPlans"), r = g(), n = to(e.providerKey), i = v(), o = de(), a = ro();
  return async (s) => {
    const c = f(n);
    if (c?.providerKey == null)
      return t.error("Unable to fetch payment plans, provider is not known"), Ot();
    const l = c.providerKey;
    if (ms(c)) {
      const d = c.approvedAmountCents ?? 0, u = s?.purchaseAmount ?? o.value ?? d, C = s?.downPaymentAmount ?? Ee(
        d,
        u,
        s?.downPaymentAmount ?? a.value
      ), P = await r.getPaymentPlans(
        c.providerKey,
        u,
        C
      ), A = i.findPaymentPlans(c.providerKey), E = hs(
        c,
        s?.productType,
        A,
        P
      );
      return i.setPaymentPlans(c.providerKey, E), P;
    } else
      return t.warn(
        `Refusing to fetch payment plans for: ${l} with response code: ${c.responseCode}`
      ), Ot();
  };
}, vs = (e, t) => m(() => {
  const r = f(e);
  return f(t).find((n) => n.id === r);
}), gs = (e) => m(() => {
  const t = f(e);
  if (t?.productType === "loan" || t?.productType === "bnpl") {
    const r = t.plans.map((n) => n.minAmountCents).filter((n) => n !== void 0);
    if (r.length)
      return Math.max(Math.min(...r), 1);
  }
  return 1;
}), Ps = (e, t) => m(() => {
  const r = e.value?.response;
  if (!r)
    return 0;
  const n = K(r.providerId), i = r.approvedAmountCents ?? 0, o = n.excludePurchaseAmountFromMaxFinancing ? Number.MAX_SAFE_INTEGER : t.value;
  return Math.min(i, o);
}), xc = (e, t) => {
  const r = f(t), n = w(), i = vs(e, r), o = m(() => i.value?.providerKey), a = m(
    () => n.getApplicationValue("purchaseAmountCents") ?? 0
  ), s = N(a.value), c = N(!1), l = ys({
    providerKey: o
  }), d = gs(i), u = Ps(
    i,
    s
  ), C = rr(
    (A, E) => {
      if (E == null)
        return;
      const q = f(i)?.productType;
      return l({
        purchaseAmount: A,
        productType: q
      });
    }
  ), P = mn(async (A) => {
    if (!(A > u.value) && !(A < d.value)) {
      c.value = !0;
      try {
        return await C(A, f(o));
      } finally {
        c.value = !1;
      }
    }
  }, 500);
  return G(s, P), G(i, (A, E) => {
    if (E?.id !== A?.id) {
      const q = A?.response?.approvedAmountCents, h = a.value;
      s.value = q == null ? h : Math.min(q, h);
    }
  }), {
    fetchingPlans: c,
    financedAmountCents: s,
    minFinanceAmountCents: d,
    maxFinanceAmountCents: u
  };
}, ws = () => {
  const e = w();
  return m({
    get: () => e.selectedPlan,
    set: (t) => e.selectedPlan = t
  });
}, Lc = (e, t) => {
  const r = v();
  return m(() => {
    const n = f(e), i = f(t), o = r.findPaymentPlan(n, i);
    if (!o)
      throw new Error(`${i} was not found for ${n}`);
    return o;
  });
}, Kc = (e) => {
  const t = b("useReviewOffer"), r = v(), n = ws(), i = N(), o = de(i), a = Qe();
  return fe(async (s, c, l, d) => {
    if (s == null) {
      t.warn("Refusing to review offer, provider key is undefined");
      return;
    }
    const u = Ji(() => s);
    i.value = s;
    const C = m(
      () => !!u.value?.requiresSelectPlan
    );
    if (c == null && C.value) {
      t.warn("Refusing to review offer, plan is undefined");
      return;
    }
    c != null && (n.value = c), l != null && (o.value = l);
    const A = r.findProviderConfig(s)?.applyModes?.find((E) => E !== "full");
    s !== r.currentProviderKey && (t.info(
      "Switching to new provider:",
      s,
      "and apply mode:",
      A
    ), await a({
      providerKey: s,
      applyMode: A
    })), await d();
  }, e);
}, Uc = (e) => {
  const t = b("useSelectOffer"), r = v(), n = Zi(), i = Qe();
  return fe(async (o, a, s) => {
    const l = Sr(() => o).value?.applyModes?.find((d) => d !== "full");
    o !== r.currentProviderKey && (t.info(
      "Switching to new provider:",
      o,
      "and apply mode:",
      l
    ), await i({
      providerKey: o,
      applyMode: l
    })), t.info(
      "Selecting payment plan:",
      a.providerKey,
      " -> ",
      a.providerPlanCode
    ), await n.selectPaymentPlan(a), await s();
  }, e);
};
var Ke, Tt;
function Ss() {
  return Tt || (Tt = 1, Ke = {}), Ke;
}
var Bc = Ss();
const As = () => window.webKiosk;
class kr {
}
class Rs extends kr {
  constructor(t, r) {
    super(), this._settings = t, this._printer = r;
  }
  _settings;
  _printer;
  documentFormat = "pdf";
  get printerName() {
    return this._settings.printerName;
  }
  get pageWidth() {
    return this._settings.pageWidth;
  }
  get pageHeight() {
    return this._settings.pageHeight ?? 11;
  }
  print(t) {
    const r = new Blob([t], {
      type: "application/pdf"
    });
    return this._printer.print(this.printerName, r);
  }
}
class bs extends kr {
  pageHeight = 11;
  pageWidth = 8.5;
  printerName = "system";
  documentFormat = "html";
  async print(t) {
    const r = new Blob([t], {
      type: "text/html"
    }), n = await this.toHtml(r);
    return new Promise((i, o) => {
      Sn({
        printable: n,
        type: "raw-html",
        onError: (a) => o(a),
        onPrintDialogClose: () => i()
      });
    });
  }
  async toHtml(t) {
    return (await t.text()).replace("size: 3.5in;", "size: letter;").replace("margin: 0;", "margin: 1in;").replace(
      'style="max-width: 100%; height: auto;"',
      'style="max-width: 3.5in; height: auto;"'
    );
  }
}
const Es = () => {
  const e = b("useReceiptPrinter"), t = As();
  return async () => {
    if (t) {
      const r = await t.printer.getSettings();
      if (r)
        return e.info(`Using Ticket Printer: ${r.printerName}`), new Rs(r, t.printer);
    }
    return e.info("Using Ticket Printer: system"), new bs();
  };
}, kc = (e) => {
  const t = g(), r = Es();
  return async (n) => {
    e.value = !0;
    try {
      const i = await r();
      if (i == null)
        throw new Error("No Receipt Printer found!");
      const o = {
        printerName: i.printerName,
        pageWidth: i.pageWidth,
        pageHeight: i.pageHeight,
        format: i.documentFormat
      }, a = await t.generateReceipt(n.providerKey, o);
      return i.print(a);
    } finally {
      e.value = !1;
    }
  };
}, qc = () => {
  const e = O();
  return m(() => e.extensions.find((r) => r.featureId === "prove")?.properties);
}, Gc = () => {
  const e = g();
  return () => e.proveResendSms();
}, _e = k("prove", {
  state: () => ({
    invalidFields: void 0,
    mobilePhone: void 0,
    prefillFields: void 0,
    ssnLast4: void 0,
    linkClicked: !1,
    completed: !1
  }),
  getters: {
    application: () => w().application,
    phoneLast4: (e) => {
      const t = e.mobilePhone;
      if (t != null)
        return t.length > 4 ? t.substring(t.length - 4) : t;
    }
  }
}), $c = () => {
  const e = g(), t = _e();
  return async (r) => {
    const n = await e.proveSendSms(r);
    return n.status === "success" && t.$patch({
      ...r
    }), n;
  };
}, Vc = () => {
  const e = j(), t = _e(), r = w();
  return async () => {
    r.$patch({
      application: {
        primary: {
          mobilePhone: t.mobilePhone
        }
      }
    });
    const n = t.invalidFields?.map(
      (s) => s.fieldPath
    ) ?? [], i = [
      [
        "primary.firstName",
        "primary.middleInitial",
        "primary.lastName",
        "primary.nameSuffix"
      ],
      ["primary.dateOfBirth"],
      ["primary.ssn"],
      ["primary.mobilePhone"],
      [
        "primary.homeAddress.line1",
        "primary.homeAddress.line2",
        "primary.homeAddress.city",
        "primary.homeAddress.state",
        "primary.homeAddress.zipCode"
      ]
    ], o = i.flatMap((s) => s);
    t.prefillFields?.length || (t.prefillFields = e.getFieldsByPath(...o));
    const a = n.map(
      (s) => i.find((c) => c.includes(s)) ?? [s]
    ).flatMap((s) => s);
    e.removeFieldsByPath(
      ...o.filter(
        (s) => !a.includes(s)
      )
    ), await L();
  };
}, Wc = (e) => {
  const t = g(), r = _e(), n = N();
  Te(async () => {
    const o = await t.getProveSmsStatus();
    return o.status === "clicked" && (r.$patch({
      linkClicked: !0
    }), await L()), o.status !== n.value?.status && (n.value = o, await e(o)), o.status !== "sent";
  }, 5e3);
}, jc = (e) => {
  const t = g(), r = w(), n = _e(), i = ne(), o = N();
  Te(async () => {
    const s = f(i), c = await t.getProveVerificationResult(s);
    if (c.status === "verified") {
      const l = c.applicationData;
      n.completed = !0, n.invalidFields = c.validationResult?.failures, l?.primary?.ssn && delete l.primary.ssn, r.$patch({
        application: {
          ...structuredClone(l)
        },
        originalApplication: {
          hasAgreedToCascade: r.application?.hasAgreedToCascade,
          ...structuredClone(l)
        }
      }), await L();
    }
    return c.status !== o.value?.status && (o.value = c, await e(c)), c.status !== "pending";
  }, 5e3);
}, Cs = ["success", "failure", "error"], Hc = (e, t) => {
  const r = b("useClarityPaySdk");
  if (r.info(`Initializing ClarityPay SDK with url ${e}`), !e)
    throw r.error("ClarityPay SDK is undefined"), new Error("ClarityPay SDK is undefined");
  const n = new URL(e).origin, { load: i, unload: o } = nr(
    `${n}/application/plugins/sdk/v3/scripts/skeps.js`,
    (l) => {
      const d = {
        mode: "inline",
        enableRawEvents: !0,
        url: e
      };
      if (globalThis.SKEPS_FINANCING === void 0) {
        r.error("ClarityPay SDK failed to init properly.");
        return;
      }
      globalThis.SKEPS_FINANCING.initProcess(d);
    },
    { manual: !0, type: "text/javascript", defer: !0 }
  ), a = async (l) => {
    Cs.includes(l.data?.type) && (r.info(
      `Received event from ClarityPay ${JSON.stringify(l.data)}`
    ), await t(l.data));
  };
  return {
    initialize: async () => (await i(), window.addEventListener("message", a), !0),
    cleanup: () => {
      o(), window.removeEventListener("message", a);
    }
  };
}, zc = (e) => {
  const t = v();
  return m(() => {
    const r = f(e);
    return t.requireProviderSession(r).mpqDeliveryDetails;
  });
}, Yc = (e) => {
  const t = g(), r = b("useMpqDeliveryDetails"), n = v(), { error: i, state: o, isLoading: a, isReady: s } = ue(
    async () => {
      const c = f(e), l = await t.getSynchronyMpqDeliveryDetails(c);
      return n.requireProviderSession(c).mpqDeliveryDetails = l, l;
    },
    void 0,
    {
      onError(c) {
        r.error("Failed getting mpq delivery details", c), B(c);
      }
    }
  );
  return {
    error: i,
    state: o,
    isLoading: a,
    isReady: s
  };
}, Jc = (e) => {
  const t = g(), r = b("useSendMpqDeliveryDetails"), n = N(!1), i = N(!1), o = N();
  return {
    error: o,
    state: n,
    isLoading: i,
    execute: fe(async (s) => {
      n.value = !1, o.value = void 0;
      try {
        await t.deliverSynchronyMpqApplicationUrl(f(e), s), n.value = !0;
      } catch (c) {
        r.error(`Failed sending mpq link to ${s}`, c), B(c), o.value = c;
      }
    }, i)
  };
}, Qc = () => {
  const e = g();
  return {
    verify: async (n) => await e.getRecaptchaVerificationResult(n),
    start: async () => e.startRecaptchaVerification()
  };
}, Is = () => {
  const e = O();
  return m(() => e.extensions.find((r) => r.featureId === "recaptcha")?.properties);
}, Zc = () => {
  const e = Is(), t = () => !!window.grecaptcha && !!window.grecaptcha.enterprise && !!window.grecaptcha.enterprise.ready;
  return {
    initializeRecaptcha: (c) => {
      const l = document.createElement("script");
      l.setAttribute(
        "src",
        c ?? `https://www.google.com/recaptcha/enterprise.js?render=${e.value?.siteKey}`
      ), document.head.appendChild(l);
    },
    executeRecaptcha: async () => {
      t() && window.grecaptcha.enterprise.ready(async () => {
        await window.grecaptcha.enterprise.execute();
      });
    },
    renderRecaptcha: (c, l) => {
      e.value && window.grecaptcha.enterprise.ready(async () => {
        window.grecaptcha.enterprise.render(c, {
          sitekey: e.value?.siteKey,
          callback: l
        });
      });
    },
    isRecaptchaInitialized: t,
    waitForRecaptchaInitialization: () => new Promise((c) => {
      const l = () => {
        t() ? c() : setTimeout(l, 250);
      };
      l();
    }),
    unloadRecaptcha: (c) => {
      const l = document.head.getElementsByTagName("script");
      for (const d of l)
        d.src.startsWith(
          c ?? `https://www.google.com/recaptcha/enterprise.js?render=${e.value?.siteKey}`
        ) && document.head.removeChild(d);
    },
    resetRecaptcha: async () => {
      t() && window.grecaptcha.enterprise.ready(async () => {
        window.grecaptcha.enterprise.reset();
      });
    }
  };
}, _t = (e) => e.waterfallStatus === "completed" || e.waterfallStatus === "expired", Xc = (e) => {
  const t = g(), r = O();
  Te(async () => {
    const i = r.waterfallResume;
    if (i == null)
      return !0;
    if (_t(i))
      return await e(i), !0;
    const o = await t.getWaterfallResumeStatus(i.waterfallSessionId);
    return r.updateResume(o), await L(), i.waterfallStatus !== o.waterfallStatus && await e(o), _t(o);
  }, 5e3);
}, el = () => {
  const e = _(), t = O(), r = g(), n = je(), i = re();
  return async (o, a, s) => {
    const l = await te().instrument("end flow", async () => {
      let u;
      try {
        u = await r.finishFlow(o, a);
      } catch (C) {
        B(C), u = {};
      }
      return t.flowType === "apply" && i({
        type: "end",
        flow: "application",
        outcome: o
      }), u;
    })(), d = l?.transition;
    if (o === "timeout") {
      const u = n.afterEach(() => {
        e.resetAll(), u();
      });
      return l;
    } else
      e.resetAll();
    if (s && window.open(s, "_blank"), d?.type === "redirect") {
      const u = Ms(d.destination, r.baseUrl);
      document.body.appendChild(u), u.submit();
    }
    return l;
  };
};
function Ms(e, t) {
  const r = document.createElement("form"), n = document.createElement("input");
  return r.action = `${t}/api/v1/flow/finish/redirect`, r.method = "POST", r.style.display = "none", n.type = "text", n.name = "destination", n.value = e, r.appendChild(n), r;
}
const tl = () => {
  const e = O(), t = g(), r = re();
  return async (n) => {
    await t.finishFlow("completed", {
      providerKey: n.providerKey
    }), r({
      type: "checkout",
      applicationId: n.versatileApplicationId,
      applicationWasResumed: e.providerResume?.requestedProviderKey === n.providerKey,
      token: n.checkoutToken
    });
  };
}, rl = () => {
  const e = O();
  return m(() => (e.storefrontSdk?.enabled ?? !1) && Ye());
}, Os = (e = {}) => {
  const t = b("useGenerateTrustEvSessionId"), r = nr(
    e.url ?? "https://cdn-us.trustev.com/trustev.min.js",
    () => {
      t.debug("trustev library loaded");
    },
    {
      manual: !0
    }
  );
  return async (n) => {
    await r.load(!0);
    const i = window.TrustevV2;
    if (!i)
      throw new Error("trustev library not found");
    return t.info(`generating a trustev session for ${n}`), new Promise((o, a) => {
      const s = window.setTimeout(
        () => a(
          new Error(
            `timed out waiting for trustev session generation for ${n}`
          )
        ),
        e.timeout ?? 5e3
      );
      i.Init(n, (c) => {
        window.clearTimeout(s), t.info(`successfully generated a trustev session for ${n}`), o(c);
      });
    });
  };
}, nl = (e) => {
  const t = Rr(), r = f(e), n = eo(r), i = O(), o = b("useSendCode");
  return async (a, s) => {
    try {
      const c = await t.sendVerificationCode(
        a,
        s
      );
      return n.value && i.flowType === "apply" && (a.email && (n.value.email = a.email), a.mobilePhone && (n.value.mobilePhone = a.mobilePhone)), c;
    } catch (c) {
      return o.error(
        `Failed to send verification code for provider ${s}: `,
        c
      ), {
        status: zt.ERROR
      };
    }
  };
}, il = () => {
  const e = Rr(), t = b("useVerifyCode");
  return async (r, n) => {
    try {
      return await e.verifyVerificationCode(
        r,
        n
      );
    } catch (i) {
      return t.error(`Error verifying code for provider ${n}: `, i), {
        status: Yt.ERROR
      };
    }
  };
};
function ol(e, t) {
  const r = N(!1), n = N(!1), i = N(!1);
  return {
    attempted: r,
    unauthorized: n,
    sendSuccess: i,
    verify: async () => {
      i.value = !1, r.value = !0;
      const s = await t();
      return n.value = s.status != Yt.SUCCESS, s;
    },
    send: async () => {
      r.value = !1, n.value = !1, i.value = !1;
      const s = await e();
      return i.value = s.status === zt.SUCCESS, s;
    }
  };
}
const sl = () => {
  const e = O();
  return () => e.extensions.find(
    (r) => r.flowPosition === "pre_application"
  ) != null;
}, Ts = () => {
  const e = w(), t = b("useIovationBlackbox");
  return async () => (t.info("loading iovation blackbox"), new Promise((r) => {
    window.io_global_object_name = "IGLOO", window.IGLOO = {
      enable_flash: !1,
      bb_callback: function(n, i) {
        i && (t.debug(
          "Updating device fingerprint with Iovation blackbox",
          n
        ), e.setApplicationValue("device.fingerprint", n), r(void 0));
      },
      loader: {
        fp_dyn: !1,
        version: "general5"
      }
    }, import("./iovation-loader-OR6Yh91O.js").then(() => t.debug("Iovation snare loaded")).catch((n) => t.error("Unable to load Iovation snare", n));
  }).then(() => t.info("Iovation device fingerprinting complete")).catch((r) => t.error("Iovation device fingerprinting failed", r)));
}, al = () => {
  const e = v(), t = Ts(), r = Os(), n = b("useFraudDetection");
  return async () => {
    let i = !1;
    for (const o of e.cascade)
      if (o.properties?.iovationEnabled && (i = !0), o.properties?.trustEvPublicKey) {
        const a = await r(
          o.properties.trustEvPublicKey
        );
        e.setTrustSessionId(o.providerKey, a);
      }
    i && (t(), n.info("loaded iovation blackbox"));
  };
};
export {
  Wi as AccountService,
  Tn as AcimaModule,
  _n as AdsModule,
  Dn as AffModule,
  Kr as AppOptionsKey,
  ci as ApplicantOfferModel,
  la as ApplicationOfferModel,
  ee as ApplicationService,
  Fn as AquaModule,
  Nn as BreadModule,
  Me as Buffers,
  aa as ClarityPayModule,
  Qs as CompositePredicate,
  Ge as Content,
  $e as ContentFormat,
  Q as ContentType,
  ht as Contents,
  hc as Countries,
  Ze as DEFAULT_GENERAL_ROUTE_MAPPINGS,
  Ic as DefaultI18nOptions,
  mt as DefaultModule,
  ge as Device,
  pi as DeviceCapability,
  xn as DividendModule,
  qe as DynamicProviderKey,
  V as FlowService,
  Ln as FortivaModule,
  Kn as FoundationModule,
  Un as GafModule,
  Dr as GeneralRouteMappingsKey,
  Bn as GenesisModule,
  U as GoogleTagManager,
  kn as GreenskyModule,
  qn as HfdModule,
  li as IncomeCollectionType,
  Ne as InjectionKeys,
  Gn as KafeneModule,
  $n as KatapultModule,
  Vn as KoalafiModule,
  Wn as LendingClubModule,
  jn as LendingPointModule,
  ko as LogicalRouter,
  ai as Modules,
  Hn as MomntModule,
  Re as PaymentPlanService,
  zn as PowerPayModule,
  Yn as ProceedModule,
  Jn as ProgressiveModule,
  Qi as ProviderSwitchResult,
  Y as RoundingMode,
  Fr as RouteConditionEvaluatorKey,
  jo as RouterPlugin,
  Qn as ServiceFinanceModule,
  Fo as Services,
  Xn as SnapModule,
  Zn as SonravaModule,
  mc as States,
  To as StipulationService,
  ye as SubmitApplicationContext,
  ve as SubmitApplicationResult,
  ei as SunlightModule,
  ti as SynchronyModule,
  ri as TdBankModule,
  _o as TermsService,
  Do as TestCaseService,
  ni as TgucModule,
  yt as URI,
  ii as UpgradeModule,
  Oo as ValidationService,
  hi as VerificationDeliveryMethod,
  Pr as VerificationService,
  oi as WatercressModule,
  si as WellsFargoModule,
  ia as and,
  lr as applicantByType,
  Zs as approvedResponse,
  Hs as arrayRemove,
  Pa as atBottomOfDocument,
  wa as atBottomOfElement,
  Ai as buildBufferSource,
  pr as buildEncryptionKey,
  na as byJointApplicant,
  ra as byPrimaryApplicant,
  Ee as calculateActualDownPaymentAmount,
  ga as calculateNextPayDate,
  sa as computedFilter,
  oa as computedQuery,
  cc as createRelativeRedirect,
  dl as daysBetween,
  zs as debounce,
  Ys as debounceAsync,
  bi as decrypt,
  zo as defineProviderRoutes,
  mi as disclosureToContent,
  vt as downloadBlob,
  wi as downloadContent,
  Pi as downloadUrl,
  Fi as enableDevTools,
  Ri as encrypt,
  Sa as enumToPath,
  ce as executeLater,
  ca as extractOptionalProviderKey,
  x as extractProviderKey,
  Ma as fillPath,
  ke as filter,
  An as first,
  wc as formatAccountNumber,
  ma as formatCurrency,
  fr as formatDate,
  ya as formatLocalDate,
  va as formatLocaleDate,
  Ca as formatPercent,
  gc as formatPhone,
  Sc as formatSsn,
  Ac as formatSsnLast4,
  ha as fullDaysBetween,
  gr as generateUUID,
  yi as getAppBaseUrl,
  fi as getDevice,
  gi as getFilenameFromUrl,
  pt as getProperty,
  K as getProviderModule,
  ul as localDate,
  Oa as maskOptionalValue,
  Ni as maskValue,
  Rt as not,
  da as optionalDisclosureToContent,
  fa as parseCurrency,
  In as pendingResponse,
  ft as prequalifiedResponse,
  Ra as preventBack,
  Be as query,
  Ia as rejectWithMessage,
  js as replaceApplyStageInUrlPath,
  Xi as reportCustomError,
  B as reportSessionError,
  cr as responseByApplicantType,
  Xs as responseByProvider,
  Mn as responseByProviderKey,
  ea as responseForApplicant,
  ta as responseForJointApplicant,
  lc as runApp,
  Aa as scrollToInvalidElement,
  pa as sendUrlThroughProxy,
  Pe as setQueryStringParams,
  Js as sleep,
  Rn as sortBy,
  Pc as toNumberOrdinal,
  No as toRouteLocation,
  Ie as toUri,
  Ta as todo,
  ua as tryToUri,
  nc as uriToEvent,
  ic as useAcceptOffer,
  fc as useAccountLookup,
  Rc as useAnswerQuiz,
  xa as useAppFieldGroupRules,
  La as useAppFieldResponse,
  pl as useAppI18n,
  Ur as useAppOptions,
  _ as useAppStore,
  eo as useApplicant,
  Wa as useApplicationDocuments,
  Ec as useApplicationLocales,
  oc as useApplicationProviderStatus,
  Oe as useApplicationService,
  w as useApplicationStore,
  fe as useAsync,
  xc as useCalculateProviderOffers,
  dc as useCheckUserExists,
  Hc as useClarityPaySdk,
  ja as useCompleteEsign,
  Ha as useConfirmPaymentPlan,
  to as useCurrentApplyResponse,
  Na as useCurrentProviderConfig,
  ne as useCurrentProviderKey,
  Da as useCurrentStaticProviderKey,
  yc as useDeliverApplicationDocuments,
  ro as useDownPaymentAmount,
  ac as useErrorRouter,
  We as useErrorStore,
  sc as useEvaluateRouteCondition,
  ys as useFetchPaymentPlans,
  Dc as useFetchZipCodeMetadata,
  j as useFieldStore,
  zc as useFindMpqDeliveryDetails,
  el as useFinishFlow,
  tl as useFinishWithCheckout,
  Ba as useFlowService,
  al as useFraudDetection,
  Lr as useGeneralRouteMappings,
  Os as useGenerateTrustEvSessionId,
  za as useGetApplyTermsUrl,
  ji as useGetInvalidFields,
  Fa as useHasProvidersAfterCurrent,
  Co as useHostedFlowConfig,
  Io as useHostedFlowPersistence,
  Ya as useInstallationAddress,
  Ka as useIsAppFieldPresent,
  Nc as useIsExploreOffersViewAvailable,
  sl as useIsPreApplicationWorkflowPresent,
  rl as useIsStorefrontSdkControlled,
  Ja as useIsTopoff,
  Mc as useLaunchMobileApply,
  W as useLocaleStore,
  b as useLogger,
  uc as useLoginProviderUser,
  Ea as useMemoize,
  _c as useMerchantLegalName,
  Tc as useMerchantName,
  Je as useMerchantStore,
  Yc as useMpqDeliveryDetails,
  ba as useNavigationStore,
  Qa as useNextLenderInCascade,
  Za as useOfferLookup,
  Xa as usePatchApplication,
  Zi as usePaymentPlanService,
  Te as usePolling,
  ec as usePreauthResponse,
  kc as usePrintReceipt,
  qc as useProveConfig,
  Gc as useProveResendSms,
  $c as useProveSendSms,
  Vc as useProveStartApplication,
  _e as useProveStore,
  Wc as useProveWaitForSms,
  jc as useProveWaitForVerification,
  Sr as useProviderConfig,
  Cc as useProviderI18n,
  Ua as useProviderInvalidFields,
  Ji as useProviderModule,
  Fc as useProviderOffers,
  v as useProviderStore,
  tc as usePublishApplicationBypassEvent,
  rc as usePublishCascadeConsent,
  re as usePublishEvent,
  de as usePurchaseAmount,
  Oc as useQrCodeLaunch,
  bc as useQuiz,
  Zc as useRecaptchaApi,
  Is as useRecaptchaConfig,
  Qc as useRecaptchaVerification,
  Va as useRefreshProviderStipulationStatus,
  wr as useRequireCurrentProviderKey,
  Lc as useRequireSelectedPlan,
  Kc as useReviewOffer,
  Ho as useRouteConditionEvaluator,
  Uc as useSelectOffer,
  ws as useSelectedPlan,
  nl as useSendCode,
  pc as useSendLoginPasscode,
  Jc as useSendMpqDeliveryDetails,
  O as useSessionStore,
  Ar as useStartProvider,
  ka as useStipulationService,
  Mo as useSubmitApplication,
  Qe as useSwitchProvider,
  qa as useTermsService,
  Ga as useTestCaseService,
  $a as useValidationService,
  ol as useVerification,
  Rr as useVerificationService,
  il as useVerifyCode,
  vc as useWaitForApplicationDocumentsVerification,
  Xc as useWaitForWaterfallResume,
  Li as validateAmex,
  Ui as validateDiscover,
  Ki as validateMastercard,
  _a as validatePAN,
  xi as validateVisa,
  hr as windowHasOpener,
  yr as windowHasParent,
  Ye as windowOpenedExternally
};
//# sourceMappingURL=index.es.js.map
